import styled from "@emotion/styled";
import * as React from "react";
import { rem, theme } from "../../styling/theme";

export const ICON_SAFE_AREA = 2;

const Icon = styled.svg({
  width: "100%",
  height: "100%",
  padding: rem(ICON_SAFE_AREA / 2),

  ["path"]: {
    transition: "all 0.4s",
    transitionTimingFunction: theme.timing.default,
  },
});

export enum IconTypeE {
  app = "app",
  archived = "archived",
  arrowBottom = "arrowBottom",
  arrowDoubleDown = "arrowDoubleDown",
  arrowLeft = "arrowLeft",
  arrowLeftCircle = "arrowLeftCircle",
  arrowRightCircle = "arrowRightCircle",
  arrowRight = "arrowRight",
  arrowRefresh = "arrowRefresh",
  attachment = "attachment",
  bell = "bell",
  bin = "bin",
  calendar = "calendar",
  chart = "chart",
  chatBubble = "chatBubble",
  check = "check",
  checkCircle = "checkCircle",
  checkCircleFillded = "checkCircleFillded",
  cross = "cross",
  crossCircle = "crossCircle",
  csv = "csv",
  document = "document",
  dots = "dots",
  download = "download",
  edit = "edit",
  eye = "eye",
  eyeStrike = "eyeStrike",
  filter = "filter",
  filterFilled = "filterFillded",
  folder = "folder",
  heart = "heart",
  igPost = "igPost",
  igStory = "igStory",
  igVideo = "igVideo",
  image = "image",
  info = "info",
  infoCircle = "infoCircle",
  link = "link",
  list = "list",
  linkExternal = "linkExternal",
  loadArrow = "loadArrow",
  magnifyingGlass = "magnifyingGlass",
  magnifyingGlassZoomIn = "magnifyingGlassZoomIn",
  megaphone = "megaphone",
  minus = "minus",
  newOffer = "newOffer",
  note = "note",
  plus = "plus",
  plusSquare = "plusSquare",
  pptx = "pptx",
  reportingPrivate = "reportingPrivate",
  reportingPublic = "reportingPublic",
  reportingManual = "reportingManual",
  sadDoc = "sadDoc",
  send = "send",
  share = "share",
  socialNetwork = "socialNetwork",
  socTiktok = "socTiktok",
  socDefault = "socDefault",
  socFacebook = "socFacebook",
  socInstagram = "socInstagram",
  socYoutube = "socYoutube",
  sort = "sort",
  star = "star",
  starRating = "starRating",
  stop = "stop",
  story = "story",
  table = "table",
  thumbs = "thumbs",
  time = "time",
  tiles = "tiles",
  upload = "upload",
  wallet = "wallet",
  xlsx = "xlsx",
}

type getIconT = (icon: IconTypeE, color?: string) => JSX.Element;
export const getIcon: getIconT = (icon, color = theme.color.textGreyColor) => {
  switch (icon) {
    case IconTypeE.app:
      return (
        <Icon viewBox="0 0 16 16">
          <path
            fill={color}
            d="M6.4,8.8H0.8c-0.2,0-0.4,0.1-0.5,0.3C0.1,9.2,0,9.4,0,9.6v5.6c0,0.2,0.1,0.4,0.3,0.5C0.4,15.9,0.6,16,0.8,16h5.6c0.2,0,0.4-0.1,0.5-0.3c0.1-0.1,0.3-0.3,0.3-0.5V9.6c0-0.2-0.1-0.4-0.3-0.5C6.8,8.9,6.6,8.8,6.4,8.8z M5.6,14.4h-4v-4h4V14.4z M15.2,0H9.6C9.4,0,9.2,0.1,9.1,0.3C8.9,0.4,8.8,0.6,8.8,0.8v5.6c0,0.2,0.1,0.4,0.3,0.5c0.1,0.1,0.3,0.3,0.5,0.3h5.6c0.2,0,0.4-0.1,0.5-0.3C15.9,6.8,16,6.6,16,6.4V0.8c0-0.2-0.1-0.4-0.3-0.5C15.6,0.1,15.4,0,15.2,0z M14.4,5.6h-4v-4h4V5.6z M15.2,8.8H9.6c-0.2,0-0.4,0.1-0.5,0.3C8.9,9.2,8.8,9.4,8.8,9.6v5.6c0,0.2,0.1,0.4,0.3,0.5C9.2,15.9,9.4,16,9.6,16h5.6c0.2,0,0.4-0.1,0.5-0.3c0.1-0.1,0.3-0.3,0.3-0.5V9.6c0-0.2-0.1-0.4-0.3-0.5C15.6,8.9,15.4,8.8,15.2,8.8z M14.4,14.4h-4v-4h4V14.4z M6.4,0H0.8C0.6,0,0.4,0.1,0.3,0.3C0.1,0.4,0,0.6,0,0.8v5.6c0,0.2,0.1,0.4,0.3,0.5c0.1,0.1,0.3,0.3,0.5,0.3h5.6c0.2,0,0.4-0.1,0.5-0.3c0.1-0.1,0.3-0.3,0.3-0.5V0.8c0-0.2-0.1-0.4-0.3-0.5C6.8,0.1,6.6,0,6.4,0z M5.6,5.6h-4v-4h4V5.6z"
          />
        </Icon>
      );
    case IconTypeE.archived:
      return (
        <Icon viewBox="0 0 16 16">
          <path
            fill={color}
            d="M16,3.2c0-1.3-1.1-2.4-2.4-2.4H2.4C1.1,0.8,0,1.9,0,3.2c0,1,0.6,1.9,1.5,2.2v7.4c0,1.3,1.1,2.4,2.4,2.4h8.2c1.3,0,2.4-1.1,2.4-2.4V5.4C15.4,5,16,4.2,16,3.2z M13,12.8c0,0.5-0.4,0.9-0.9,0.9H3.9c-0.5,0-0.9-0.4-0.9-0.9V5.6h10V12.8z M13.6,4.1H2.4c-0.5,0-0.9-0.4-0.9-0.9s0.4-0.9,0.9-0.9h11.2c0.5,0,0.9,0.4,0.9,0.9S14.1,4.1,13.6,4.1z M9.7,8.8H6.4C6,8.8,5.6,8.5,5.6,8.1S6,7.3,6.4,7.3h3.3c0.4,0,0.7,0.3,0.7,0.7S10.1,8.8,9.7,8.8z"
          />
        </Icon>
      );
    case IconTypeE.arrowLeft:
      return (
        <Icon viewBox="0 0 16 16">
          <path
            fill={color}
            d="M11.3,16c-0.4,0-0.7-0.1-0.9-0.4L3.7,8.9c-0.5-0.5-0.5-1.3,0-1.9l6.7-6.7c0.5-0.5,1.3-0.5,1.9,0c0.5,0.5,0.5,1.3,0,1.9L6.5,8l5.7,5.7c0.5,0.5,0.5,1.3,0,1.9C12,15.9,11.7,16,11.3,16z"
          />
        </Icon>
      );
    case IconTypeE.arrowLeftCircle:
      return (
        <Icon viewBox="0 0 16 16">
          <path
            fill={color}
            d="M8,0C3.6,0,0,3.6,0,8s3.6,8,8,8s8-3.6,8-8S12.4,0,8,0z M10.4,8.6l-3.3,3.3c-0.1,0.1-0.3,0.2-0.5,0.2c-0.2,0-0.4-0.1-0.6-0.2c-0.3-0.3-0.3-0.8,0-1.1L8.8,8L6,5.3C5.7,5,5.7,4.5,6,4.2c0.1-0.2,0.4-0.2,0.5-0.2c0.2,0,0.4,0,0.5,0.3l3.3,3.3C10.7,7.8,10.7,8.2,10.4,8.6z"
          />
        </Icon>
      );
    case IconTypeE.arrowRightCircle:
      return (
        <Icon viewBox="0 0 16 16">
          <path
            fill={color}
            d="M8,16c4.4,0,8-3.6,8-8s-3.6-8-8-8S0,3.6,0,8S3.6,16,8,16z M5.6,7.4l3.3-3.3C9,4,9.2,3.9,9.4,3.9S9.8,4,10,4.1c0.3,0.3,0.3,0.8,0,1.1L7.2,8l2.8,2.7c0.3,0.3,0.3,0.8,0,1.1C9.9,12,9.6,12,9.5,12c-0.2,0-0.4,0-0.5-0.3L5.7,8.4C5.3,8.2,5.3,7.8,5.6,7.4z"
          />
        </Icon>
      );
    case IconTypeE.arrowRight:
      return (
        <Icon viewBox="0 0 16 16">
          <path
            fill={color}
            d="M4.7,0c0.4,0,0.7,0.1,0.9,0.4l6.7,6.7c0.5,0.5,0.5,1.3,0,1.9l-6.7,6.7c-0.5,0.5-1.3,0.5-1.9,0c-0.5-0.5-0.5-1.3,0-1.9L9.5,8L3.8,2.3C3.3,1.8,3.3,1,3.8,0.4C4,0.1,4.3,0,4.7,0z"
          />
        </Icon>
      );
    case IconTypeE.arrowRefresh:
      return (
        <Icon viewBox="0 0 16 16">
          <path
            fill={color}
            d="M14.3,10.8h-3.6c-0.2,0-0.4,0.1-0.6,0.2c-0.2,0.1-0.2,0.4-0.2,0.6c0,0.2,0.1,0.4,0.2,0.6c0.2,0.1,0.4,0.2,0.6,0.2h1.9c-0.9,0.9-2,1.6-3.3,1.8s-2.5,0.2-3.7-0.3s-2.2-1.3-2.9-2.3C2,10.5,1.6,9.3,1.6,8c0-0.2-0.1-0.4-0.2-0.6C1.2,7.3,1,7.2,0.8,7.2S0.4,7.3,0.2,7.4C0.1,7.6,0,7.8,0,8c0,1.6,0.5,3.1,1.3,4.4c0.9,1.3,2.1,2.3,3.5,2.9c1.4,0.6,3,0.8,4.6,0.5c1.5-0.3,3-1,4.1-2.1v1.4c0,0.2,0.1,0.4,0.2,0.6c0.1,0.2,0.4,0.2,0.6,0.2s0.4-0.1,0.6-0.2c0.2-0.1,0.2-0.4,0.2-0.6v-3.6c0-0.2-0.1-0.4-0.2-0.6C14.7,10.9,14.5,10.8,14.3,10.8z M8,0C5.9,0,4,0.8,2.5,2.2V0.8c0-0.2-0.1-0.4-0.2-0.6C2.1,0.1,1.9,0,1.7,0S1.3,0.1,1.1,0.2C1,0.4,0.9,0.6,0.9,0.8v3.6C0.9,4.6,1,4.8,1.1,5c0.2,0.2,0.4,0.2,0.6,0.2h3.6c0.2,0,0.4-0.1,0.6-0.2C6,4.8,6.1,4.6,6.1,4.4C6.1,4.2,6,4,5.9,3.8C5.7,3.7,5.5,3.6,5.3,3.6H3.4c0.9-0.9,2-1.6,3.3-1.8c1.2-0.3,2.5-0.2,3.7,0.3c1.2,0.5,2.2,1.3,2.9,2.3C14,5.5,14.4,6.7,14.4,8c0,0.2,0.1,0.4,0.2,0.6c0.1,0.2,0.4,0.2,0.6,0.2s0.4-0.1,0.6-0.2C15.9,8.4,16,8.2,16,8c0-1.1-0.2-2.1-0.6-3.1c-0.4-1-1-1.9-1.7-2.6C12.9,1.6,12,1,11.1,0.6C10.1,0.2,9.1,0,8,0z"
          />
        </Icon>
      );
    case IconTypeE.arrowBottom:
      return (
        <Icon viewBox="0 0 16 16">
          <path
            fill={color}
            d="M16,4.7c0,0.4-0.1,0.7-0.4,0.9l-6.7,6.7c-0.5,0.5-1.3,0.5-1.9,0L0.4,5.6c-0.5-0.5-0.5-1.3,0-1.9c0.5-0.5,1.3-0.5,1.9,0L8,9.5l5.7-5.7c0.5-0.5,1.3-0.5,1.9,0C15.9,4,16,4.3,16,4.7z"
          />
        </Icon>
      );
    case IconTypeE.bin:
      return (
        <Icon viewBox="0 0 16 16">
          <path
            fill={color}
            d="M14.4,2.5h-4V2c0-1.2-1.3-1.9-2.4-2C6.8,0,5.5,0.8,5.5,2v0.5H1.7C1.3,2.5,1,2.9,1,3.2s0.3,0.7,0.7,0.7h0.6v9.3c0,1.4,1.1,2.9,2.9,2.9h5.5c1.7,0,2.9-1.5,2.9-2.9V4h0.8C14.7,4,15,3.6,15,3.3S14.7,2.5,14.4,2.5z M7,2c0-0.3,0.5-0.6,1-0.6s1,0.3,1,0.6v0.5H7C7,2.5,7,2,7,2z M12.1,13.3c0,0.6-0.6,1.4-1.4,1.4H5.2c-0.8,0-1.4-0.8-1.4-1.4V4h3.1h1.9H12L12.1,13.3L12.1,13.3z M7,6.3v6C7,12.7,6.6,13,6.3,13c-0.4,0-0.7-0.3-0.7-0.7v-6c0-0.4,0.3-0.7,0.7-0.7C6.7,5.6,7,6,7,6.3z M8.8,6.3c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7v6c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7V6.3z"
          />
        </Icon>
      );
    case IconTypeE.arrowDoubleDown:
      return (
        <Icon viewBox="0 0 16 16">
          <path
            fill={color}
            d="M15.2,8.6c0,0.4-0.1,0.6-0.4,0.8l-6,6c-0.4,0.4-1.2,0.4-1.7,0l-5.9-6c-0.4-0.4-0.4-1.2,0-1.7c0.4-0.4,1.2-0.4,1.7,0L8,12.9l5.1-5.1c0.4-0.4,1.2-0.4,1.7,0C15.1,8,15.2,8.2,15.2,8.6z M15.2,1.5c0,0.4-0.1,0.6-0.4,0.8l-6,6c-0.4,0.4-1.2,0.4-1.7,0l-5.9-6c-0.4-0.4-0.4-1.2,0-1.7c0.4-0.4,1.2-0.4,1.7,0L8,5.8l5.1-5.1c0.4-0.4,1.2-0.4,1.7,0C15.1,0.9,15.2,1.1,15.2,1.5z"
          />
        </Icon>
      );
    case IconTypeE.plusSquare:
      return (
        <Icon viewBox="0 0 16 16" enableBackground="new 0 0 16 16">
          <path
            fill={color}
            d="M11.2,16H4.8C2.2,16,0,13.8,0,11.2V4.8C0,2.2,2.2,0,4.8,0h6.4C13.8,0,16,2.2,16,4.8v6.4C16,13.8,13.8,16,11.2,16z M4.8,1.6C3,1.6,1.6,3,1.6,4.8v6.4c0,1.8,1.4,3.2,3.2,3.2h6.4c1.8,0,3.2-1.4,3.2-3.2V4.8c0-1.8-1.4-3.2-3.2-3.2H4.8z M5.8,8.8h1.6v1.6c0,0.2,0.1,0.4,0.2,0.6c0.2,0.2,0.4,0.2,0.6,0.2c0.2,0,0.4-0.1,0.6-0.2C8.9,10.8,9,10.6,9,10.4V8.8h1.6c0.2,0,0.4-0.1,0.6-0.2c0.2-0.2,0.2-0.4,0.2-0.6c0-0.2-0.1-0.4-0.2-0.6c-0.2-0.2-0.4-0.2-0.6-0.2H9V5.6C9,5.4,8.9,5.2,8.8,5C8.6,4.9,8.4,4.8,8.2,4.8C8,4.8,7.8,4.9,7.7,5C7.5,5.2,7.4,5.4,7.4,5.6v1.6H5.8c-0.2,0-0.4,0.1-0.6,0.2C5.1,7.6,5,7.8,5,8c0,0.2,0.1,0.4,0.2,0.6C5.4,8.7,5.6,8.8,5.8,8.8z"
          />
        </Icon>
      );
    case IconTypeE.attachment:
      return (
        <Icon viewBox="0 0 16 16" enableBackground="new 0 0 16 16">
          <path
            fill={color}
            d="M13.4,8.5l-5,5c-0.7,0.6-1.5,0.9-2.4,0.9c-0.9,0-1.7-0.4-2.3-1c-0.6-0.6-1-1.5-1-2.3s0.3-1.7,0.9-2.4L10,2.1c0.4-0.4,0.9-0.6,1.4-0.6c0.5,0,1.1,0.2,1.4,0.6c0.4,0.4,0.6,0.9,0.6,1.4S13.3,4.6,12.9,5l-5.6,5.6c-0.1,0.1-0.1,0.1-0.2,0.1c-0.1,0-0.2,0.1-0.2,0.1c-0.1,0-0.2,0-0.2,0c-0.1,0-0.1-0.1-0.2-0.1c-0.1-0.1-0.1-0.1-0.1-0.2c0-0.1-0.1-0.2-0.1-0.2c0-0.1,0-0.2,0-0.2c0-0.1,0.1-0.1,0.1-0.2l4.2-4.2c0.2-0.2,0.2-0.4,0.2-0.6s-0.1-0.4-0.2-0.6c-0.2-0.2-0.4-0.2-0.6-0.2S9.6,4.3,9.4,4.4L5.2,8.6C5,8.8,4.9,9.1,4.7,9.3c-0.1,0.3-0.2,0.6-0.2,0.9s0.1,0.6,0.2,0.9c0.1,0.3,0.3,0.5,0.5,0.7c0.4,0.4,1,0.6,1.6,0.6s1.2-0.2,1.6-0.6L14,6.2c0.6-0.7,1-1.6,1-2.6c0-0.9-0.4-1.9-1.1-2.5C13.3,0.4,12.3,0,11.4,0c-0.9,0-1.9,0.3-2.6,1L2.3,7.5C1.4,8.5,1,9.7,1,11.1c0,1.3,0.6,2.6,1.5,3.5C3.5,15.5,4.7,16,6,16c1.3,0,2.6-0.5,3.5-1.4l5-5c0.1-0.1,0.1-0.2,0.2-0.3c0-0.1,0.1-0.2,0.1-0.3c0-0.1,0-0.2-0.1-0.3c0-0.1-0.1-0.2-0.2-0.3c-0.1-0.1-0.2-0.1-0.3-0.2c-0.1,0-0.2-0.1-0.3-0.1c-0.1,0-0.2,0-0.3,0.1C13.6,8.3,13.5,8.4,13.4,8.5L13.4,8.5z"
          />
        </Icon>
      );
    case IconTypeE.image:
      return (
        <Icon viewBox="0 0 16 16" enableBackground="new 0 0 16 16">
          <path
            fill={color}
            d="M13.5,0H2.4C1.7,0,1.1,0.3,0.7,0.8C0.3,1.2,0,1.8,0,2.4v11.2c0,0.7,0.3,1.3,0.7,1.7c0.4,0.5,1,0.7,1.7,0.7h11.2c1.5,0,2.5-1.4,2.5-2.5V2.4c0-0.7-0.3-1.3-0.7-1.7C14.8,0.3,14.2,0,13.5,0z M2.4,14.4c-0.2,0-0.4-0.1-0.5-0.3c-0.1-0.1-0.3-0.3-0.3-0.5v-3.5l2.6-2.7c0.1-0.1,0.1-0.1,0.3-0.2c0.1-0.1,0.2-0.1,0.3-0.1s0.2,0,0.3,0.1c0.1,0.1,0.2,0.1,0.3,0.2l7,6.9L2.4,14.4z M14.1,14.1L9.9,9.8l0.7-0.7C10.7,9,10.8,9,10.9,8.9c0.1-0.1,0.2-0.1,0.3-0.1c0.1,0,0.2,0,0.3,0.1C11.6,9,11.8,9,11.8,9.1l2.6,2.7v1.9L14.1,14.1z M14.3,9.5L12.8,8c-0.5-0.5-1.1-0.7-1.7-0.7S9.9,7.6,9.5,8L8.8,8.8L6.4,6.4C6,6,5.4,5.8,4.8,5.8S3.5,6,3.1,6.4L1.6,7.9V2.4c0-0.2,0.1-0.4,0.3-0.5C2,1.7,2.2,1.6,2.4,1.6h11.2c0.2,0,0.4,0.1,0.5,0.3c0.1,0.1,0.3,0.3,0.3,0.5C14.3,2.4,14.3,9.5,14.3,9.5z M9.2,3.2c-0.3,0-0.5,0.1-0.7,0.2C8.3,3.6,8.2,3.8,8,4C8,4.2,8,4.4,8,4.7C8,4.9,8.1,5.2,8.3,5.3c0.2,0.2,0.4,0.3,0.6,0.3c0.2,0.1,0.5,0,0.7-0.1c0.2-0.1,0.4-0.3,0.5-0.5c0.1-0.2,0.2-0.4,0.2-0.7c0-0.3-0.1-0.6-0.3-0.9C9.8,3.4,9.5,3.2,9.2,3.2z"
          />
        </Icon>
      );
    case IconTypeE.infoCircle:
      return (
        <Icon viewBox="0 0 16 16">
          <path
            fill={color}
            d="M8,0C3.6,0,0,3.6,0,8s3.6,8,8,8s8-3.6,8-8S12.4,0,8,0z M14.7,8c0,3.7-3,6.7-6.7,6.7s-6.7-3-6.7-6.7s3-6.7,6.7-6.7S14.7,4.3,14.7,8z M8.9,4.5C8.9,5,8.5,5.4,8,5.4S7.1,5,7.1,4.5S7.5,3.7,8,3.7S8.9,4,8.9,4.5z M8.7,7v4.6c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7v-1.2V7c0-0.4,0.3-0.7,0.7-0.7C8.4,6.3,8.7,6.7,8.7,7z"
          />
        </Icon>
      );
    case IconTypeE.info:
      return (
        <Icon viewBox="0 0 16 16">
          <path
            fill={color}
            d="M9.6,1.6c0,0.9-0.7,1.6-1.6,1.6S6.4,2.5,6.4,1.6S7.1,0,8,0S9.6,0.7,9.6,1.6z M9.3,6.2v8.5C9.3,15.4,8.7,16,8,16s-1.3-0.6-1.3-1.3v-2.1V6.2c0-0.7,0.6-1.3,1.3-1.3S9.3,5.5,9.3,6.2z"
          />
        </Icon>
      );
    case IconTypeE.send:
      return (
        <Icon viewBox="0 0 16 16" enableBackground="new 0 0 16 16">
          <path
            fill={color}
            d="M14.6,5.8L3.5,0.2C3,0,2.5,0,2,0C1.5,0.1,1.1,0.3,0.7,0.7C0.4,1,0.1,1.4,0,1.9C0,2.4,0,2.9,0.2,3.4l1.9,4.3c0,0.1,0.1,0.2,0.1,0.3c0,0.1,0,0.2-0.1,0.3l-1.9,4.3C0,12.9,0,13.3,0,13.7c0,0.4,0.2,0.8,0.4,1.1c0.2,0.3,0.5,0.6,0.9,0.8c0.3,0.2,0.7,0.3,1.1,0.3c0.4,0,0.7-0.1,1.1-0.3l11.1-5.6c0.4-0.2,0.7-0.5,1-0.9c0.2-0.4,0.4-0.8,0.4-1.3c0-0.4-0.1-0.9-0.4-1.3C15.3,6.3,15,6,14.6,5.8L14.6,5.8z M13.9,8.7L2.7,14.2c-0.1,0.1-0.3,0.1-0.5,0.1c-0.2,0-0.3-0.1-0.4-0.2c-0.1-0.1-0.2-0.3-0.2-0.4c0-0.2,0-0.3,0.1-0.5l1.9-4.3c0-0.1,0-0.1,0.1-0.2h5.5c0.2,0,0.4-0.1,0.6-0.2c0.1-0.1,0.2-0.4,0.2-0.6c0-0.2-0.1-0.4-0.2-0.6S9.3,7.2,9.1,7.2H3.6c0-0.1,0-0.1-0.1-0.2L1.7,2.7C1.6,2.6,1.6,2.4,1.6,2.2c0-0.2,0.1-0.3,0.2-0.4C2,1.7,2.1,1.6,2.3,1.6c0.2,0,0.3,0,0.5,0.1l11.1,5.6c0.1,0.1,0.2,0.2,0.3,0.3c0.1,0.1,0.1,0.3,0.1,0.4c0,0.1,0,0.3-0.1,0.4C14.1,8.5,14,8.6,13.9,8.7z"
          />
        </Icon>
      );
    case IconTypeE.bell:
      return (
        <Icon viewBox="0 0 16 16" enableBackground="new 0 0 16 16">
          <path
            fill={color}
            d="M13.3,9.2C13.2,9.1,13,9,12.8,8.9c0-0.9,0-2.3,0-2.5c0-1.2-0.5-2.5-1.4-3.4c-0.7-0.8-1.7-1.2-2.7-1.4V0.8C8.7,0.3,8.3,0,7.9,0S7.2,0.3,7.2,0.8v0.9C6.2,1.8,5.3,2.3,4.5,3C3.7,4,3.2,5.2,3.2,6.4c0,0.3,0,1.7,0,2.5C2.9,9,2.7,9.1,2.6,9.2c-0.5,0.3-1.1,0.9-1.1,2.1v1.6c0,0.2,0.1,0.4,0.2,0.6c0.1,0.1,0.3,0.2,0.6,0.2h0l2.5,0C5.2,15,6.4,16,7.9,16s2.7-1,3.1-2.4l2.6,0h0c0.2,0,0.4-0.1,0.6-0.2c0.1-0.1,0.2-0.3,0.2-0.6v-1.6C14.4,10.1,13.8,9.5,13.3,9.2z M5.7,4.1c0.6-0.6,1.4-1,2.3-1c0.9,0,1.7,0.4,2.3,1c0.6,0.6,0.9,1.4,0.9,2.3c0,0.3,0,1.6,0,2.4l-3.3,0l0,0h0h0l0,0l-3.1,0c0-0.9,0-2.2,0-2.4C4.7,5.6,5.1,4.8,5.7,4.1z M7.9,14.4c-0.6,0-1.1-0.3-1.4-0.8l1.4,0l1.4,0C9,14.1,8.5,14.4,7.9,14.4z M12.8,12.1l-4.9,0l0,0h0h0l0,0l-4.9,0v-0.8c0-0.5,0.1-0.9,0.9-0.9c0,0,0.1,0,0.1,0l3.8,0l4,0c0,0,0.1,0,0.1,0c0.8,0,0.9,0.4,0.9,0.9L12.8,12.1L12.8,12.1z"
          />
        </Icon>
      );
    case IconTypeE.document:
      return (
        <Icon viewBox="0 0 16 16" enableBackground="new 0 0 16 16">
          <path
            fill={color}
            d="M13.9,3.9l-3.7-3.7C10.1,0.1,9.9,0,9.8,0H3.3C2.5,0,1.9,0.7,1.9,1.4v13.2c0,0.8,0.6,1.4,1.4,1.4h9.4c0.8,0,1.4-0.6,1.4-1.4V4.2C14,4.1,14,4,13.9,3.9z M10.3,1.6l2.1,2.1h-1.7c-0.3,0-0.5-0.2-0.5-0.5V1.6z M12.6,15.1H3.3c-0.3,0-0.5-0.2-0.5-0.5V1.4C2.8,1.2,3,1,3.3,1h6.1v2.3c0,0.8,0.6,1.4,1.4,1.4h2.3v9.9C13.1,14.9,12.9,15.1,12.6,15.1z M10.7,6.6H5.1c-0.3,0-0.5,0.2-0.5,0.5c0,0.3,0.2,0.5,0.5,0.5h5.6c0.3,0,0.5-0.2,0.5-0.5C11.2,6.9,11,6.6,10.7,6.6z M10.7,8.5H5.1C4.9,8.5,4.7,8.7,4.7,9c0,0.3,0.2,0.5,0.5,0.5h5.6c0.3,0,0.5-0.2,0.5-0.5C11.2,8.7,11,8.5,10.7,8.5z M10.7,10.4H5.1c-0.3,0-0.5,0.2-0.5,0.5s0.2,0.5,0.5,0.5h5.6c0.3,0,0.5-0.2,0.5-0.5S11,10.4,10.7,10.4z M8.9,12.3H5.1c-0.3,0-0.5,0.2-0.5,0.5s0.2,0.5,0.5,0.5h3.7c0.3,0,0.5-0.2,0.5-0.5S9.1,12.3,8.9,12.3z"
          />
        </Icon>
      );
    case IconTypeE.download:
      return (
        <Icon viewBox="0 0 16 16" enableBackground="new 0 0 16 16">
          <path
            fill={color}
            d="M4.3,8C4,7.7,4,7.2,4.3,6.9c0.3-0.3,0.8-0.3,1.1,0l1.8,1.8V0.9c0-0.4,0.3-0.8,0.8-0.8c0,0,0,0,0,0c0,0,0,0,0,0c0.4,0,0.8,0.3,0.8,0.8v7.8l1.8-1.8c0.3-0.3,0.8-0.3,1.1,0C12,7.2,12,7.7,11.7,8l-3.1,3.1c0,0,0,0,0,0c-0.1,0.1-0.1,0.1-0.2,0.2c0,0,0,0,0,0c-0.1,0-0.2,0.1-0.3,0.1c0,0,0,0,0,0c0,0,0,0,0,0c-0.1,0-0.2,0-0.3-0.1c0,0,0,0,0,0c-0.1,0-0.2-0.1-0.2-0.2c0,0,0,0,0,0L4.3,8z M15.2,7.7c-0.4,0-0.8,0.3-0.8,0.8v5.1c0,0.4-0.3,0.7-0.7,0.7H8.1H7.9H2.3c-0.4,0-0.7-0.3-0.7-0.7V8.5c0-0.4-0.3-0.8-0.8-0.8S0,8.1,0,8.5v5.1c0,1.2,1,2.3,2.3,2.3h5.6h0.2h5.6c1.2,0,2.3-1,2.3-2.3V8.5C16,8.1,15.7,7.7,15.2,7.7z"
          />
        </Icon>
      );
    case IconTypeE.dots:
      return (
        <Icon viewBox="0 0 16 16" enableBackground="new 0 0 16 16">
          <path
            fill={color}
            d="M4.3,8c0,1.2-0.9,2.1-2.1,2.1S0,9.2,0,8s0.9-2.1,2.1-2.1S4.3,6.8,4.3,8z M8,5.9C6.8,5.9,5.9,6.8,5.9,8s0.9,2.1,2.1,2.1s2.1-0.9,2.1-2.1S9.2,5.9,8,5.9z M13.9,5.9c-1.2,0-2.1,0.9-2.1,2.1s0.9,2.1,2.1,2.1S16,9.2,16,8S15.1,5.9,13.9,5.9z"
          />
        </Icon>
      );
    case IconTypeE.cross:
      return (
        <Icon viewBox="0 0 16 16" enableBackground="new 0 0 16 16">
          <path
            fill={color}
            d="M10,8l5.5-5.5c0.3-0.3,0.4-0.6,0.4-1c0-0.4-0.1-0.7-0.4-1c-0.6-0.6-1.5-0.6-2,0L8,6L2.5,0.5c-0.6-0.6-1.5-0.6-2,0c-0.6,0.6-0.6,1.5,0,2L6,8l-5.5,5.5c-0.6,0.6-0.6,1.5,0,2c0.6,0.6,1.5,0.6,2,0L8,10l5.5,5.5c0.3,0.3,0.6,0.4,1,0.4c0.4,0,0.7-0.1,1-0.4c0.6-0.6,0.6-1.5,0-2L10,8z"
          />
        </Icon>
      );
    case IconTypeE.crossCircle:
      return (
        <Icon viewBox="0 0 16 16" enableBackground="new 0 0 16 16">
          <path
            fill={color}
            d="M8,16c-4.4,0-8-3.6-8-8s3.6-8,8-8s8,3.6,8,8S12.4,16,8,16z M8,1.3c-3.7,0-6.7,3-6.7,6.7s3,6.7,6.7,6.7s6.7-3,6.7-6.7S11.7,1.3,8,1.3z M8.9,8l2.6-2.6c0.3-0.3,0.3-0.7,0-0.9c-0.3-0.3-0.7-0.3-0.9,0L8,7.1L5.4,4.5c-0.3-0.3-0.7-0.3-0.9,0c-0.3,0.3-0.3,0.7,0,0.9L7.1,8l-2.6,2.6c-0.3,0.3-0.3,0.7,0,0.9c0.1,0.1,0.3,0.2,0.5,0.2s0.3-0.1,0.5-0.2L8,9l2.6,2.6c0.1,0.1,0.3,0.2,0.5,0.2s0.3-0.1,0.5-0.2c0.3-0.3,0.3-0.7,0-0.9L8.9,8z"
          />
        </Icon>
      );
    case IconTypeE.check:
      return (
        <Icon viewBox="0 0 16 16" enableBackground="new 0 0 16 16">
          <path
            fill={color}
            d="M15.6,3c0.5,0.5,0.5,1.2,0,1.5L7,13.1c-0.2,0.2-0.5,0.3-0.8,0.3c-0.3,0-0.7-0.2-0.8-0.3l-5-5c-0.5-0.5-0.5-1.2,0-1.5c0.5-0.5,1.2-0.5,1.5,0L6,10.8l8-8C14.5,2.5,15.1,2.5,15.6,3z"
          />
        </Icon>
      );
    case IconTypeE.minus:
      return (
        <Icon viewBox="0 0 16 16" enableBackground="new 0 0 16 16">
          <path
            fill={color}
            d="M14.9,9H1.1c-0.6,0-1-0.4-1-1s0.4-1,1-1h13.8c0.6,0,1,0.4,1,1S15.4,9,14.9,9z"
          />
        </Icon>
      );
    case IconTypeE.megaphone:
      return (
        <Icon viewBox="0 0 16 16" enableBackground="new 0 0 16 16">
          <path
            fill={color}
            d="M14.4,0c-0.1,0-0.2,0-0.3,0.1c-0.1,0.1-0.2,0.1-0.3,0.2c-0.1,0.1-0.1,0.1-0.2,0.3c-0.1,0.1-0.1,0.2-0.1,0.3v0.5c-0.7,0.9-1.5,1.5-2.5,2C10.1,3.7,9.1,4,8,4H3.2C2.5,4,1.9,4.3,1.5,4.7c-0.4,0.5-0.7,1-0.7,1.7V8c0,0.7,0.3,1.3,0.7,1.7c0.5,0.5,1.1,0.7,1.7,0.7h0.4l-1.9,4.5c-0.1,0.1-0.1,0.3-0.1,0.4s0.1,0.3,0.1,0.4c0.1,0.1,0.2,0.2,0.3,0.3C2.1,16,2.3,16,2.4,16h3.2c0.1,0,0.3-0.1,0.5-0.1c0.1-0.1,0.2-0.2,0.3-0.3l2.2-5.1c1,0.1,1.9,0.3,2.8,0.8c0.9,0.5,1.7,1.1,2.3,1.9v0.5c0,0.2,0.1,0.4,0.3,0.5c0.1,0.1,0.3,0.3,0.5,0.3c0.2,0,0.4-0.1,0.5-0.3c0.1-0.1,0.3-0.3,0.3-0.5V0.8c0-0.1,0-0.2-0.1-0.3c-0.1-0.1-0.1-0.2-0.2-0.3c-0.1-0.1-0.1-0.1-0.3-0.2C14.6,0,14.5,0,14.4,0z M3.2,8.8C3,8.8,2.8,8.7,2.7,8.5C2.5,8.4,2.4,8.2,2.4,8V6.4c0-0.2,0.1-0.4,0.3-0.5C2.8,5.7,3,5.6,3.2,5.6H4v3.2C4,8.8,3.2,8.8,3.2,8.8z M5.1,14.4H3.6l1.7-4h1.5L5.1,14.4z M13.6,10.8c-1.6-1.3-3.5-2-5.6-2H5.6V5.6H8c2.1,0,4-0.7,5.6-2V10.8z"
          />
        </Icon>
      );
    case IconTypeE.note:
      return (
        <Icon viewBox="0 0 16 16" enableBackground="new 0 0 16 16">
          <path
            fill={color}
            d="M11.2,9.6H4.8c-0.2,0-0.4,0.1-0.5,0.3C4.1,10,4,10.2,4,10.4s0.1,0.4,0.3,0.5c0.1,0.1,0.3,0.3,0.5,0.3h6.4c0.2,0,0.4-0.1,0.5-0.3c0.1-0.1,0.3-0.3,0.3-0.5s-0.1-0.4-0.3-0.5C11.6,9.7,11.4,9.6,11.2,9.6z M11.2,6.4H6.4C6.2,6.4,6,6.5,5.9,6.7C5.7,6.8,5.6,7,5.6,7.2c0,0.2,0.1,0.4,0.3,0.5C6,7.9,6.2,8,6.4,8h4.8c0.2,0,0.4-0.1,0.5-0.3C11.9,7.6,12,7.4,12,7.2c0-0.2-0.1-0.4-0.3-0.5C11.6,6.5,11.4,6.4,11.2,6.4z M14.4,1.6H12V0.8c0-0.2-0.1-0.4-0.3-0.5C11.6,0.1,11.4,0,11.2,0c-0.2,0-0.4,0.1-0.5,0.3c-0.1,0.1-0.3,0.3-0.3,0.5v0.8H8.8V0.8c0-0.2-0.1-0.4-0.3-0.5C8.4,0.1,8.2,0,8,0C7.8,0,7.6,0.1,7.5,0.3C7.3,0.4,7.2,0.6,7.2,0.8v0.8H5.6V0.8c0-0.2-0.1-0.4-0.3-0.5C5.2,0.1,5,0,4.8,0C4.6,0,4.4,0.1,4.3,0.3C4.1,0.4,4,0.6,4,0.8v0.8H1.6c-0.2,0-0.4,0.1-0.5,0.3C0.9,2,0.8,2.2,0.8,2.4v11.2c0,0.7,0.3,1.3,0.7,1.7c0.4,0.5,1,0.7,1.7,0.7h9.6c0.7,0,1.3-0.3,1.7-0.7c0.5-0.5,0.7-1.1,0.7-1.7V2.4c0-0.2-0.1-0.4-0.3-0.5C14.8,1.7,14.6,1.6,14.4,1.6z M13.6,13.6c0,0.2-0.1,0.4-0.3,0.5c-0.1,0.1-0.3,0.3-0.5,0.3H3.2c-0.2,0-0.4-0.1-0.5-0.3c-0.1-0.1-0.3-0.3-0.3-0.5V3.2H4V4c0,0.2,0.1,0.4,0.3,0.5c0.1,0.1,0.3,0.3,0.5,0.3c0.2,0,0.4-0.1,0.5-0.3C5.5,4.4,5.6,4.2,5.6,4V3.2h1.6V4c0,0.2,0.1,0.4,0.3,0.5C7.6,4.7,7.8,4.8,8,4.8c0.2,0,0.4-0.1,0.5-0.3C8.7,4.4,8.8,4.2,8.8,4V3.2h1.6V4c0,0.2,0.1,0.4,0.3,0.5c0.1,0.1,0.3,0.3,0.5,0.3c0.2,0,0.4-0.1,0.5-0.3C11.9,4.4,12,4.2,12,4V3.2h1.6C13.6,3.2,13.6,13.6,13.6,13.6z"
          />
        </Icon>
      );
    case IconTypeE.heart:
      return (
        <Icon viewBox="0 0 16 16" enableBackground="new 0 0 16 16">
          <path
            fill={color}
            d="M8,15.4l-0.3-0.2C6,14.1,3.9,12.8,2.4,11C0.8,9.1,0,7.1,0,4.9c0-2.4,1.9-4.3,4.3-4.3c1.9,0,3.1,1.1,3.7,1.9c0.6-0.8,1.9-1.9,3.7-1.9c2.3,0,4.2,1.9,4.3,4.3c0,2.1-0.8,4.1-2.4,6c-1.5,1.8-3.6,3.1-5.3,4.2L8,15.4z"
          />
        </Icon>
      );
    case IconTypeE.plus:
      return (
        <Icon viewBox="0 0 16 16" enableBackground="new 0 0 16 16">
          <path
            fill={color}
            d="M14.9,7H9V1.1c0-0.5-0.4-1-1-1s-1,0.4-1,1V7H1.1c-0.6,0-1,0.4-1,1c0,0.6,0.4,1,1,1H7v5.9c0,0.6,0.4,1,1,1s1-0.4,1-1V9h5.9c0.5,0,1-0.4,1-1C15.9,7.4,15.5,7,14.9,7z"
          />
        </Icon>
      );
    case IconTypeE.sadDoc:
      return (
        <Icon viewBox="0 0 16 16" enableBackground="new 0 0 16 16">
          <path
            fill={color}
            d="M2.1,4.2C2.1,4.2,2.1,4.2,2.1,4.2c0,0,0,0.1,0,0.1c0,0,0,0,0,0v11.3c0,0.2,0.1,0.3,0.3,0.3h11.3c0.2,0,0.3-0.1,0.3-0.3V0.4c0-0.2-0.1-0.3-0.3-0.3H6c0,0,0,0,0,0c0,0-0.1,0-0.1,0c0,0,0,0,0,0c0,0,0,0-0.1,0c0,0,0,0,0,0c0,0,0,0,0,0L2.1,4.2C2.1,4.2,2.1,4.2,2.1,4.2z M5.7,1.1v3H3L5.7,1.1z M2.6,4.6H6c0.2,0,0.3-0.1,0.3-0.3V0.6h7.1v14.7H2.6V4.6z M6.8,7.4C6.8,7.3,6.8,7.3,6.8,7.4C6.8,7.3,6.8,7.3,6.8,7.4C6.9,7.2,6.9,7.1,6.8,7c0,0,0,0,0,0c0,0,0,0-0.1-0.1c0,0,0,0,0,0L5.3,5.8C5.2,5.7,5,5.7,4.9,5.8C4.9,6,4.9,6.1,5,6.2l0.8,0.6H4.9C4.7,6.9,4.6,7,4.6,7.2c0,0.2,0.1,0.3,0.3,0.3h0.9L5,8.1c-0.1,0.1-0.1,0.3,0,0.4c0.1,0.1,0.3,0.1,0.4,0L6.8,7.4C6.8,7.4,6.8,7.4,6.8,7.4z M11.1,6.9h-0.9L11,6.2c0.1-0.1,0.1-0.3,0-0.4c-0.1-0.1-0.3-0.1-0.4,0L9.2,6.9c0,0,0,0,0,0c0,0,0,0-0.1,0.1c0,0,0,0,0,0c0,0.1,0,0.2,0,0.2c0,0,0,0,0,0c0,0,0,0,0.1,0.1c0,0,0,0,0,0l1.4,1.1c0.1,0.1,0.3,0.1,0.4,0c0.1-0.1,0.1-0.3,0-0.4l-0.8-0.6h0.9c0.2,0,0.3-0.1,0.3-0.3C11.4,7,11.3,6.9,11.1,6.9z M8,9.4C7,9.4,6,10,5.6,11c-0.1,0.1,0,0.3,0.2,0.4c0.1,0.1,0.3,0,0.4-0.2C6.5,10.5,7.2,10,8,10s1.5,0.5,1.8,1.2c0,0.1,0.1,0.2,0.2,0.2c0.1,0,0.2,0,0.3-0.1c0.1-0.1,0.1-0.2,0-0.3C10,10,9,9.4,8,9.4z"
          />
        </Icon>
      );
    case IconTypeE.loadArrow:
      return (
        <Icon viewBox="0 0 16 16" enableBackground="new 0 0 16 16">
          <path
            fill={color}
            d="M8,2V0.1C8,0,8.1,0,8.2,0L12,2.9c0.1,0,0.1,0.1,0,0.2L8.2,5.9C8.1,6,8,5.9,8,5.8V3.9C5.1,4,2.8,6.4,3,9.3c0.2,2.5,2.2,4.5,4.7,4.7c2.7,0.2,4.9-1.7,5.3-4.2C13.1,9.3,13.5,9,14,9l0,0c0.6,0,1,0.5,0.9,1.1c-0.6,3.6-3.9,6.3-7.7,5.8C4,15.6,1.5,13,1.1,9.8C0.6,5.6,3.9,2.1,8,2z"
          />
        </Icon>
      );
    case IconTypeE.link:
      return (
        <Icon viewBox="0 0 16 16" enableBackground="new 0 0 16 16">
          <path
            fill={color}
            d="M6.1,10.8c0,0.4-0.4,0.8-0.8,0.8H3.6c-1.8,0-3.4-1.5-3.6-3.3c0-0.1,0-0.1,0-0.2c0,0,0,0,0-0.1c0,0,0,0,0-0.1C0,8,0,7.9,0,7.9c0.2-1.8,1.8-3.3,3.6-3.3h1.7c0.4,0,0.8,0.3,0.8,0.8S5.8,6.1,5.3,6.1H3.6c-1.1,0-2,1-2,2c0,0.9,0.9,2,2,2h1.7C5.8,10.1,6.1,10.4,6.1,10.8z M16,8.1C16,8.1,16,8,16,8.1c0-0.1,0-0.2,0-0.2c-0.2-1.8-1.8-3.3-3.6-3.3h-1.7c-0.4,0-0.8,0.3-0.8,0.8s0.4,0.8,0.8,0.8h1.7c1.1,0,2,1,2,2c0,0.9-0.9,2-2,2h-1.7c-0.4,0-0.8,0.3-0.8,0.8s0.4,0.8,0.8,0.8h1.7c1.8,0,3.4-1.5,3.6-3.3C16,8.3,16,8.2,16,8.1C16,8.1,16,8.1,16,8.1z M4.1,8c0,0.4,0.4,0.8,0.8,0.8h5.9c0.4,0,0.8-0.3,0.8-0.8s-0.4-0.8-0.8-0.8H4.9C4.5,7.3,4.1,7.6,4.1,8z"
          />
        </Icon>
      );
    case IconTypeE.list:
      return (
        <Icon viewBox="0 0 16 16" enableBackground="new 0 0 16 16">
          <path
            fill={color}
            d="M0.77,3.6c0-0.53,0.38-0.97,0.84-0.97h8.73c0.46,0,0.84,0.43,0.84,0.97s-0.38,0.97-0.84,0.97H1.61C1.14,4.57,0.77,4.13,0.77,3.6z M1.61,8.96h12.79c0.46,0,0.84-0.43,0.84-0.97s-0.38-0.97-0.84-0.97H1.61C1.14,7.03,0.77,7.46,0.77,8S1.14,8.96,1.61,8.96z M14.39,11.43H1.61c-0.46,0-0.84,0.43-0.84,0.97c0,0.53,0.38,0.97,0.84,0.97h12.79c0.46,0,0.84-0.43,0.84-0.97C15.23,11.86,14.86,11.43,14.39,11.43z"
          />
        </Icon>
      );
    case IconTypeE.linkExternal:
      return (
        <Icon viewBox="0 0 16 16" enableBackground="new 0 0 16 16">
          <path
            fill={color}
            d="M14,6.7C14,6.3,13.7,6,13.3,6s-0.7,0.3-0.7,0.7h0c0,3.3,0,7.7,0,7.7H1.5v-11h8.1c0.4,0,0.8-0.3,0.8-0.8C10.3,2.3,10,2,9.6,2H0.9C0.4,2,0,2.3,0,2.9v12.3C0,15.7,0.4,16,0.9,16h12.3c0.4,0,0.9-0.3,0.9-0.9L14,6.7L14,6.7z"
          />
          <path
            fill={color}
            d="M15.3,0c0,0,0,0-0.1,0h-3.7c-0.4,0-0.7,0.3-0.7,0.8s0.3,0.8,0.7,0.8h2L6,9.1C5.9,9.2,5.8,9.4,5.8,9.6c0,0.4,0.3,0.7,0.7,0.7c0.2,0,0.4-0.1,0.5-0.2l7.6-7.7v2.1c0,0.4,0.3,0.8,0.7,0.8c0.4,0,0.7-0.3,0.7-0.8V0.8C16,0.3,15.7,0,15.3,0z"
          />
        </Icon>
      );
    case IconTypeE.socialNetwork:
      return (
        <Icon viewBox="0 0 16 16" enableBackground="new 0 0 16 16">
          <path
            fill={color}
            d="M12.9,10.3c-0.4,0-0.8,0.1-1.2,0.3c-0.4,0.2-0.7,0.4-1,0.8L5.8,8.9C6,8.3,6,7.8,5.8,7.2l4.9-2.5c0.4,0.5,1,0.9,1.7,1c0.7,0.1,1.4,0,1.9-0.3c0.6-0.3,1-0.9,1.3-1.5c0.2-0.6,0.2-1.3,0-2c-0.2-0.6-0.7-1.2-1.3-1.5C13.8,0,13.1-0.1,12.4,0c-0.7,0.1-1.3,0.5-1.7,1c-0.4,0.5-0.7,1.2-0.7,1.9c0,0.2,0,0.3,0.1,0.5L5.1,6C4.7,5.6,4.2,5.3,3.6,5.2C3.1,5.1,2.5,5.2,2,5.4C1.4,5.6,1,6,0.7,6.5C0.4,6.9,0.2,7.5,0.2,8c0,0.6,0.2,1.1,0.5,1.6s0.8,0.8,1.3,1.1c0.5,0.2,1.1,0.3,1.6,0.2c0.6-0.1,1.1-0.4,1.5-0.8l5,2.5c0,0.2,0,0.3-0.1,0.5c0,0.6,0.2,1.1,0.5,1.6c0.3,0.5,0.8,0.8,1.3,1.1c0.5,0.2,1.1,0.3,1.7,0.2c0.6-0.1,1.1-0.4,1.5-0.8c0.4-0.4,0.7-0.9,0.8-1.5c0.1-0.6,0.1-1.1-0.2-1.7c-0.2-0.5-0.6-1-1.1-1.3C14,10.4,13.5,10.3,12.9,10.3z M12.9,1.5c0.3,0,0.6,0.1,0.8,0.2c0.2,0.2,0.4,0.4,0.5,0.6c0.1,0.3,0.1,0.5,0.1,0.8c-0.1,0.3-0.2,0.5-0.4,0.7c-0.2,0.2-0.5,0.3-0.7,0.4c-0.3,0.1-0.6,0-0.8-0.1c-0.3-0.1-0.5-0.3-0.6-0.5c-0.2-0.2-0.2-0.5-0.2-0.8c0-0.4,0.2-0.7,0.4-1C12.2,1.6,12.5,1.5,12.9,1.5z M3.1,9.5c-0.3,0-0.6-0.1-0.8-0.2C2.1,9.1,1.9,8.9,1.8,8.6C1.7,8.3,1.6,8,1.7,7.8C1.7,7.5,1.9,7.2,2.1,7c0.2-0.2,0.5-0.3,0.7-0.4s0.6,0,0.8,0.1C3.9,6.8,4.1,7,4.3,7.2C4.4,7.5,4.5,7.8,4.5,8c0,0.4-0.2,0.7-0.4,1C3.8,9.3,3.5,9.5,3.1,9.5z M12.9,14.6c-0.3,0-0.6-0.1-0.8-0.2c-0.2-0.2-0.4-0.4-0.5-0.6c-0.1-0.3-0.1-0.5-0.1-0.8c0.1-0.3,0.2-0.5,0.4-0.7c0.2-0.2,0.5-0.3,0.7-0.4c0.3-0.1,0.6,0,0.8,0.1c0.3,0.1,0.5,0.3,0.6,0.5c0.2,0.2,0.2,0.5,0.2,0.8c0,0.4-0.2,0.7-0.4,1C13.6,14.4,13.3,14.6,12.9,14.6z"
          />
        </Icon>
      );
    case IconTypeE.socDefault:
      return (
        <Icon viewBox="0 0 16 16" enableBackground="new 0 0 16 16">
          <path
            fill={color}
            d="M12.5,9.9c-0.8,0-1.7,0.4-2.2,1.1L6.3,8.8C6.4,8.5,6.4,8.3,6.4,8c0-0.3-0.1-0.6-0.1-0.9l4.1-2.2C11,5.5,11.8,6,12.6,6c1.5,0,2.6-1.2,2.6-2.7c-0.1-1.5-1.3-2.7-2.7-2.7c-1.5,0-2.6,1.2-2.6,2.6v0.3L5.5,5.9C5,5.4,4.3,5.1,3.5,5.1C1.9,5.1,0.6,6.4,0.6,8c0,1.6,1.3,2.9,2.9,2.9c0.8,0,1.6-0.3,2.1-0.9l4.3,2.4v0.2c0,1.5,1.2,2.6,2.6,2.6s2.6-1.2,2.6-2.6S14,9.9,12.5,9.9z M13.8,12.5c0,0.7-0.6,1.3-1.3,1.3s-1.3-0.6-1.3-1.3c0-0.7,0.6-1.3,1.3-1.3S13.8,11.8,13.8,12.5z M11.2,3.3c0-0.7,0.6-1.3,1.3-1.3s1.3,0.6,1.3,1.3c0,0.7-0.6,1.3-1.3,1.3S11.2,4.1,11.2,3.3z M5.1,8c0,0.8-0.7,1.5-1.6,1.5c-0.9,0-1.6-0.7-1.6-1.6c0-0.8,0.7-1.5,1.6-1.5C4.4,6.4,5.1,7.1,5.1,8z"
          />
        </Icon>
      );
    case IconTypeE.socTiktok:
      return (
        <Icon viewBox="0 0 16 16" enableBackground="new 0 0 16 16">
          <path d="M8,0C3.6,0,0,3.6,0,8s3.6,8,8,8s8-3.6,8-8S12.4,0,8,0z" />
          <path
            fill="#EE1D52"
            d="M10.02,6.41c0.61,0.44,1.36,0.69,2.17,0.69V5.55c-0.15,0-0.31-0.02-0.46-0.05v1.23c-0.81,0-1.56-0.26-2.17-0.69
          v3.18c0,1.59-1.29,2.88-2.88,2.88c-0.59,0-1.14-0.18-1.6-0.49c0.52,0.53,1.25,0.87,2.06,0.87c1.59,0,2.88-1.29,2.88-2.88L10.02,6.41
          L10.02,6.41z M10.58,4.84c-0.31-0.34-0.52-0.78-0.56-1.27v-0.2H9.59C9.7,3.99,10.07,4.52,10.58,4.84L10.58,4.84z M6.09,10.38
          c-0.17-0.23-0.27-0.51-0.27-0.8c0-0.73,0.59-1.32,1.32-1.32c0.14,0,0.27,0.02,0.4,0.06V6.74c-0.15-0.02-0.3-0.03-0.46-0.03v1.24
          c-0.13-0.04-0.26-0.06-0.4-0.06c-0.73,0-1.32,0.59-1.32,1.32C5.37,9.72,5.66,10.16,6.09,10.38z"
          />
          <path
            fill="#FFFFFF"
            d="M9.57,6.03c0.61,0.44,1.36,0.69,2.17,0.69V5.5c-0.45-0.1-0.85-0.33-1.15-0.66C10.07,4.52,9.7,3.99,9.59,3.37
          H8.45v6.22c0,0.72-0.59,1.31-1.32,1.31c-0.43,0-0.81-0.2-1.05-0.52c-0.43-0.22-0.72-0.66-0.72-1.18c0-0.73,0.59-1.32,1.32-1.32
          c0.14,0,0.27,0.02,0.4,0.06V6.71C5.52,6.74,4.26,8.02,4.26,9.59c0,0.78,0.31,1.49,0.82,2.01c0.46,0.31,1.01,0.49,1.6,0.49
          c1.59,0,2.88-1.29,2.88-2.88L9.57,6.03z"
          />
          <path
            fill="#69C9D0"
            d="M11.74,5.5V5.17c-0.41,0-0.81-0.11-1.15-0.33C10.89,5.18,11.29,5.41,11.74,5.5z M9.59,3.37
          C9.58,3.31,9.57,3.25,9.57,3.19v-0.2H8v6.22c0,0.72-0.59,1.31-1.32,1.31c-0.21,0-0.41-0.05-0.59-0.14c0.24,0.32,0.62,0.52,1.05,0.52
          c0.73,0,1.31-0.59,1.32-1.31V3.37H9.59z M7.08,6.71V6.36C6.95,6.34,6.82,6.33,6.69,6.33c-1.59,0-2.88,1.29-2.88,2.88
          c0,1,0.51,1.87,1.28,2.39c-0.51-0.52-0.82-1.23-0.82-2.01C4.26,8.02,5.52,6.74,7.08,6.71L7.08,6.71z"
          />
        </Icon>
      );
    case IconTypeE.socFacebook:
      return (
        <Icon viewBox="0 0 16 16" enableBackground="new 0 0 16 16">
          <g>
            <circle fill="#3B5998" cx="8" cy="8" r="8" />
            <path
              fill="#FFFFFF"
              d="M9.6,8H8.4v4.2H6.7V8H5.9V6.5h0.8V5.6c0-0.7,0.3-1.7,1.7-1.7l1.3,0v1.4H8.8c-0.2,0-0.4,0.1-0.4,0.4v0.9h1.3L9.6,8z"
            />
          </g>
        </Icon>
      );
    case IconTypeE.socInstagram:
      return (
        <Icon viewBox="0 0 16 16" enableBackground="new 0 0 16 16">
          <g>
            <linearGradient
              id="SVGID_1_"
              gradientUnits="userSpaceOnUse"
              x1="2.3431"
              y1="13.6569"
              x2="13.6569"
              y2="2.3431"
            >
              <stop offset="0" style={{ stopColor: "#FFC107" }} />
              <stop offset="0.507" style={{ stopColor: "#F44336" }} />
              <stop offset="0.99" style={{ stopColor: "#9C27B0" }} />
            </linearGradient>
            <path
              fill="url(#SVGID_1_)"
              d="M8,0C3.6,0,0,3.6,0,8c0,4.4,3.6,8,8,8c4.4,0,8-3.6,8-8C16,3.6,12.4,0,8,0z"
            />
          </g>
          <path
            fill="#FFFFFF"
            d="M8,3.3c-1.9,0-3.8-0.2-4.5,1.6C3.2,5.6,3.3,6.6,3.3,8c0,1.2,0,2.4,0.2,3.1c0.7,1.8,2.6,1.6,4.5,1.6c1.9,0,3.8,0.2,4.5-1.6c0.3-0.8,0.2-1.7,0.2-3.1c0-1.9,0.1-3-0.8-3.9C11,3.1,9.8,3.3,8,3.3L8,3.3z M7.6,4.1c4.1,0,4.6-0.5,4.3,5.8c-0.1,2.2-1.8,2-3.9,2c-3.8,0-3.9-0.1-3.9-3.9C4.1,4.2,4.4,4.1,7.6,4.1L7.6,4.1z M10.5,4.9c-0.3,0-0.6,0.3-0.6,0.6C10,5.8,10.2,6,10.5,6c0.3,0,0.6-0.3,0.6-0.6C11.1,5.2,10.8,4.9,10.5,4.9z M8,5.6C6.7,5.6,5.6,6.7,5.6,8s1.1,2.4,2.4,2.4s2.4-1.1,2.4-2.4S9.3,5.6,8,5.6L8,5.6z M8,6.4c2.1,0,2.1,3.2,0,3.2C5.9,9.6,5.9,6.4,8,6.4z"
          />
        </Icon>
      );
    case IconTypeE.socYoutube:
      return (
        <Icon viewBox="0 0 16 16" enableBackground="new 0 0 16 16">
          <circle fill="#FF0000" cx="8" cy="8" r="8" />
          <path
            fill="#FFFFFF"
            d="M11.8,6.1c-0.1-0.3-0.4-0.6-0.7-0.7C10.5,5.2,8,5.2,8,5.2s-2.5,0-3.1,0.2C4.5,5.5,4.2,5.7,4.2,6.1C4,6.7,4,8,4,8s0,1.3,0.2,1.9c0.1,0.3,0.4,0.6,0.7,0.7C5.5,10.8,8,10.8,8,10.8s2.5,0,3.1-0.2c0.3-0.1,0.6-0.4,0.7-0.7C12,9.3,12,8,12,8S12,6.7,11.8,6.1z M7.2,9.2V6.8L9.3,8L7.2,9.2z"
          />
        </Icon>
      );
    case IconTypeE.story:
      return (
        <Icon viewBox="0 0 16 16" enableBackground="new 0 0 16 16">
          <path
            fill={color}
            d="M9.6,10.9c-0.2,0-0.3-0.1-0.4-0.2L7,8.6V4.2c0-0.3,0.3-0.6,0.6-0.6c0.3,0,0.6,0.3,0.6,0.6v3.8l1.8,1.8c0.2,0.2,0.2,0.6,0,0.9C9.9,10.9,9.8,10.9,9.6,10.9z M13.4,0.5c-0.3,0-0.6,0.3-0.6,0.6v1.2c-1.3-1.1-3-1.8-4.8-1.8C3.9,0.5,0.5,3.9,0.5,8c0,4.1,3.3,7.4,7.4,7.4c0.3,0,0.6-0.3,0.6-0.6c0-0.3-0.3-0.6-0.6-0.6c-3.4,0-6.2-2.8-6.2-6.2c0-3.4,2.8-6.2,6.2-6.2c1.5,0,2.9,0.6,4,1.5h-1.3c-0.3,0-0.6,0.3-0.6,0.6s0.3,0.6,0.6,0.6H14V1.1C14,0.8,13.7,0.5,13.4,0.5z M14.7,7.3c-0.4,0-0.7,0.3-0.7,0.7c0,0.4,0.3,0.7,0.7,0.7c0.4,0,0.7-0.3,0.7-0.7C15.4,7.6,15.1,7.3,14.7,7.3z M14.2,9.9c-0.4,0-0.7,0.3-0.7,0.7s0.3,0.7,0.7,0.7s0.7-0.3,0.7-0.7S14.6,9.9,14.2,9.9z M12.7,12c-0.4,0-0.7,0.3-0.7,0.7s0.3,0.7,0.7,0.7s0.7-0.3,0.7-0.7S13.1,12,12.7,12z M10.6,13.5c-0.4,0-0.7,0.3-0.7,0.7s0.3,0.7,0.7,0.7c0.4,0,0.7-0.3,0.7-0.7S10.9,13.5,10.6,13.5z"
          />
        </Icon>
      );
    case IconTypeE.time:
      return (
        <Icon viewBox="0 0 16 16" enableBackground="new 0 0 16 16">
          <path
            fill={color}
            d="M8,16c-4.4,0-8-3.6-8-8s3.6-8,8-8s8,3.6,8,8S12.4,16,8,16z M8,1.3c-3.7,0-6.7,3-6.7,6.7s3,6.7,6.7,6.7s6.7-3,6.7-6.7S11.7,1.3,8,1.3z M10.3,9.9L8.6,8.4v-4c0-0.4-0.2-0.7-0.7-0.7c-0.4,0-0.7,0.2-0.7,0.7v4.4c0,0.1,0.1,0.4,0.2,0.5l1.9,1.6c0.3,0.2,0.7,0.1,1-0.1C10.5,10.6,10.6,10.2,10.3,9.9z"
          />
        </Icon>
      );
    case IconTypeE.tiles:
      return (
        <Icon viewBox="0 0 16 16" enableBackground="new 0 0 16 16">
          <path
            fill={color}
            d="M9.94,13.57v-0.99c0-0.14,0.11-0.25,0.25-0.25h1.06c0.09,0,0.17-0.07,0.17-0.17V3.33c0-0.09-0.07-0.17-0.17-0.17h-1.06c-0.14,0-0.25-0.11-0.25-0.25V1.93c0-0.14,0.11-0.25,0.25-0.25h1.06c0.91,0,1.65,0.74,1.65,1.65v8.84c0,0.91-0.74,1.65-1.65,1.65h-1.06C10.05,13.82,9.94,13.7,9.94,13.57z M13.85,11.86h0.5c0.91,0,1.65-0.74,1.65-1.65V4.09c0-0.91-0.74-1.65-1.65-1.65h-0.5c-0.14,0-0.25,0.11-0.25,0.25v0.99c0,0.14,0.11,0.25,0.25,0.25h0.5c0.09,0,0.17,0.07,0.17,0.17v6.12c0,0.09-0.07,0.17-0.17,0.17h-0.5c-0.14,0-0.25,0.11-0.25,0.25v0.99C13.6,11.75,13.71,11.86,13.85,11.86z M1.63,0.96h6.03c0.9,0,1.63,0.74,1.63,1.65v10.78c0,0.91-0.73,1.65-1.63,1.65H1.63C0.73,15.04,0,14.3,0,13.39L0,2.61C0,1.7,0.73,0.96,1.63,0.96z M7.66,2.44H1.63c-0.09,0-0.17,0.07-0.17,0.17v6.55l1.13,1.04l2.47-2.28c0.28-0.26,0.71-0.26,0.99,0l1.77,1.63V2.61C7.82,2.52,7.75,2.44,7.66,2.44z M1.63,13.56h6.03c0.09,0,0.17-0.07,0.17-0.17v-1.83L5.56,9.48l-2.47,2.28c-0.14,0.13-0.32,0.19-0.49,0.19s-0.35-0.06-0.49-0.19l-0.64-0.59v2.22C1.47,13.48,1.54,13.56,1.63,13.56z M3.69,5.63c0.53,0,0.96-0.43,0.96-0.96S4.22,3.71,3.69,3.71S2.73,4.14,2.73,4.67S3.16,5.63,3.69,5.63z"
          />
        </Icon>
      );
    case IconTypeE.newOffer:
      return (
        <Icon viewBox="0 0 16 16" enableBackground="new 0 0 16 16">
          <path
            fill={color}
            d="M14.1,8.1c-0.1,0-0.2,0-0.3-0.1L12,7.2l-1.7,0.9c-0.2,0.1-0.5,0.1-0.7,0C9.4,7.9,9.3,7.6,9.3,7.4l0.3-1.9L8.3,4.1C8.1,3.9,8,3.6,8.1,3.4S8.4,3,8.6,3l1.9-0.3l0.9-1.8c0.2-0.4,0.9-0.4,1.2,0l0.9,1.8L15.4,3c0.2,0,0.4,0.2,0.5,0.4s0,0.5-0.2,0.7l-1.4,1.4l0.3,1.9c0,0.2-0.1,0.5-0.3,0.6C14.3,8.1,14.2,8.1,14.1,8.1z M12,5.8c0.1,0,0.2,0,0.3,0.1l0.9,0.5l-0.2-1c0-0.2,0-0.4,0.2-0.6l0.7-0.7l-1-0.1c-0.2,0-0.4-0.2-0.5-0.4L12,2.7l-0.4,0.9c-0.1,0.2-0.3,0.3-0.5,0.4l-1,0.1l0.7,0.7C11,4.9,11,5.1,11,5.3l-0.2,1l0.9-0.5C11.8,5.8,11.9,5.8,12,5.8z"
          />
          <path
            fill={color}
            d="M15.3,9.1c-0.4,0-0.7,0.3-0.7,0.7v3.1c0,0.7-0.6,1.3-1.3,1.3H2.7c-0.7,0-1.4-0.6-1.4-1.3V5.5c0-0.2,0-0.3,0.1-0.5l4.1,4.1C5.7,9.3,5.9,9.4,6,9.4h1.4C7.8,9.4,8,9.1,8,8.8S7.8,8.1,7.5,8.1H6.3L2.5,4.2c0.1,0,0.2,0,0.2,0h3.2c0.4,0,0.6-0.3,0.6-0.6S6.3,2.9,5.9,2.9H2.7C1.2,2.9,0.1,4,0.1,5.5v7.4c0,1.5,1.2,2.7,2.6,2.7h10.6c1.5,0,2.7-1.2,2.7-2.7V9.8C16,9.4,15.7,9.1,15.3,9.1z"
          />
        </Icon>
      );
    case IconTypeE.checkCircle:
      return (
        <Icon viewBox="0 0 16 16">
          <path
            fill={color}
            d="M8,16c-4.4,0-8-3.6-8-8s3.6-8,8-8s8,3.6,8,8S12.4,16,8,16z M8,1.3c-3.7,0-6.7,3-6.7,6.7s3,6.7,6.7,6.7s6.7-3,6.7-6.7S11.7,1.3,8,1.3z M7.8,10.6l4-4c0.3-0.3,0.3-0.7,0-1s-0.7-0.3-1,0L7.3,9.1L5.4,7.2c-0.3-0.3-0.7-0.3-1,0s-0.3,0.7,0,1l2.4,2.4c0.1,0.1,0.3,0.2,0.5,0.2S7.7,10.8,7.8,10.6z"
          />
        </Icon>
      );
    case IconTypeE.checkCircleFillded:
      return (
        <Icon viewBox="0 0 16 16">
          <path
            fill={color}
            d="M8,16c-4.4,0-8-3.6-8-8s3.6-8,8-8s8,3.6,8,8S12.4,16,8,16z M7.8,10.6l4-4c0.3-0.3,0.3-0.7,0-1s-0.7-0.3-1,0L7.3,9.1L5.4,7.2c-0.3-0.3-0.7-0.3-1,0s-0.3,0.7,0,1l2.4,2.4c0.1,0.1,0.3,0.2,0.5,0.2S7.7,10.8,7.8,10.6z"
          />
        </Icon>
      );
    case IconTypeE.magnifyingGlass:
      return (
        <Icon viewBox="0 0 16 16">
          <path
            fill={color}
            d="M15.8,14.7l-3-3l0,0c1.2-1.4,1.7-3.3,1.6-5.1c-0.2-1.8-1-3.5-2.4-4.8C10.6,0.5,8.9,0,7,0C5.2,0.1,3.4,0.8,2.1,2.1S0.1,5.2,0,7c0,1.9,0.6,3.6,1.8,5c1.2,1.4,2.9,2.2,4.8,2.4c1.8,0.1,3.7-0.4,5.1-1.6l0,0l3,3c0.1,0.1,0.3,0.2,0.5,0.2c0.2,0,0.4-0.1,0.5-0.2C16.1,15.5,16.1,15,15.8,14.7z M7.1,12.9C6,12.9,4.9,12.6,4,12c-0.8-0.6-1.5-1.5-2-2.5S1.5,7.2,1.7,6.1C1.9,5,2.5,4,3.3,3.3C4,2.5,5,1.9,6.1,1.7c0.4-0.1,0.7-0.1,1.1-0.1c0.7,0,1.5,0.1,2.1,0.4c1,0.4,1.9,1.1,2.5,2.1c0.6,0.9,0.9,2,0.9,3.1c0,1.5-0.6,2.9-1.6,4C10.1,12.4,8.6,12.9,7.1,12.9z"
          />
        </Icon>
      );
    case IconTypeE.magnifyingGlassZoomIn:
      return (
        <Icon viewBox="0 0 16 16">
          <path
            fill={color}
            d="M15.8,14.7l-3-3l0,0c1.2-1.4,1.7-3.3,1.6-5.1c-0.2-1.8-1-3.5-2.4-4.8C10.6,0.5,8.9,0,7,0C5.2,0.1,3.4,0.8,2.1,2.1S0.1,5.2,0,7c0,1.9,0.6,3.6,1.8,5c1.2,1.4,2.9,2.2,4.8,2.4c1.8,0.1,3.7-0.4,5.1-1.6l0,0l3,3c0.1,0.1,0.3,0.2,0.5,0.2c0.2,0,0.4-0.1,0.5-0.2C16.1,15.5,16.1,15,15.8,14.7z M7.1,12.9C6,12.9,4.9,12.6,4,12c-0.8-0.6-1.5-1.5-2-2.5S1.5,7.2,1.7,6.1C1.9,5,2.5,4,3.3,3.3C4,2.5,5,1.9,6.1,1.7c0.4-0.1,0.7-0.1,1.1-0.1c0.7,0,1.5,0.1,2.1,0.4c1,0.4,1.9,1.1,2.5,2.1c0.6,0.9,0.9,2,0.9,3.1c0,1.5-0.6,2.9-1.6,4C10.1,12.4,8.6,12.9,7.1,12.9z M10.5,7.2c0,0.4-0.3,0.7-0.8,0.7l-1.8,0l0,1.8c0,0.4-0.3,0.7-0.8,0.7c-0.2,0-0.4-0.1-0.5-0.2C6.5,10.2,6.4,10,6.4,9.8l0-1.8l-1.8,0c-0.4,0-0.7-0.3-0.7-0.8C3.8,7,3.9,6.8,4,6.6c0.1-0.1,0.3-0.2,0.5-0.2l1.8,0l0-1.8c0-0.4,0.3-0.7,0.8-0.7c0.4,0,0.7,0.3,0.7,0.8l0,1.8l1.8,0C10.2,6.4,10.5,6.8,10.5,7.2z"
          />
        </Icon>
      );

    case IconTypeE.edit:
      return (
        <Icon viewBox="0 0 16 16" enableBackground="new 0 0 16 16">
          <path
            fill={color}
            d="M0.7,14.6c-0.2,0-0.4,0.1-0.5,0.2S0,15.1,0,15.3c0,0.2,0.1,0.4,0.2,0.5C0.3,15.9,0.5,16,0.7,16h14.6c0.2,0,0.4-0.1,0.5-0.2c0.1-0.1,0.2-0.3,0.2-0.5c0-0.2-0.1-0.4-0.2-0.5c-0.1-0.1-0.3-0.2-0.5-0.2H0.7z M14.3,3.9c0-0.1-0.1-0.2-0.2-0.2l-3.4-3.5c-0.1-0.1-0.1-0.1-0.2-0.2C10.4,0,10.3,0,10.2,0c-0.1,0-0.2,0-0.3,0.1c-0.1,0-0.2,0.1-0.2,0.2L7.5,2.5L1.8,8.1C1.8,8.2,1.7,8.3,1.7,8.4c0,0.1-0.1,0.2-0.1,0.3v3.4c0,0.2,0.1,0.4,0.2,0.5c0.1,0.1,0.3,0.2,0.5,0.2h3.4c0.1,0,0.2,0,0.3-0.1s0.2-0.1,0.2-0.1l5.6-5.6l2.3-2.3c0.1-0.1,0.1-0.1,0.2-0.2c0-0.1,0.1-0.2,0.1-0.3C14.4,4.1,14.4,4,14.3,3.9z M10.3,6.5l-4.8,4.8H3V8.9l0,0L7.9,4L10.3,6.5L10.3,6.5z M11.4,5.5L8.9,3l1.3-1.3l2.5,2.5L11.4,5.5z"
          />
        </Icon>
      );
    case IconTypeE.star:
      return (
        <Icon viewBox="0 0 16 16">
          <path
            fill={color}
            d="M8,0.4l2.5,5L16,6.2l-4,3.9l0.9,5.5L8,13l-4.9,2.6L4,10.1L0,6.2l5.5-0.8L8,0.4z"
          />
        </Icon>
      );
    case IconTypeE.starRating:
      return (
        <Icon viewBox="0 0 16 16">
          <path
            fill={color}
            d="M14.5,7.6L10.6,7c-0.1-0.1-0.1-0.1-0.2-0.2L8.6,3.5C8.5,3.3,8.3,3.1,8,3.2c-0.3,0-0.5,0.1-0.6,0.4L5.6,7c0,0,0,0,0,0c0,0,0,0,0,0l-4,0.4C1.3,7.5,1.1,7.7,1,7.9s0,0.6,0.2,0.7l3,2.6c0,0,0,0,0.1,0c0,0,0,0,0,0.1L3.5,15c-0.1,0.3,0,0.5,0.3,0.7c0.2,0.2,0.5,0.2,0.7,0.1L8,14c0,0,0,0,0,0c0,0,0,0,0.1,0l3.6,1.8c0.1,0,0.2,0.1,0.3,0.1c0.2,0,0.3,0,0.4-0.1c0.2-0.2,0.3-0.4,0.3-0.7L12,11.4c0,0,0,0,0,0l2.9-2.5C15,8.6,15.1,8.3,15,8.1S14.7,7.6,14.5,7.6z M10.9,10.4C10.9,10.4,10.9,10.4,10.9,10.4c-0.4,0.4-0.4,0.9-0.4,1.1c0,0,0,0.1,0,0.1l0.5,2.3l-2.3-1.2c-0.2-0.1-0.5-0.2-0.7-0.2c-0.3,0-0.5,0.1-0.7,0.2l-2.2,1.1l0.5-2.3c0,0,0-0.1,0-0.1c0-0.3,0-0.9-0.6-1.3L3.3,8.7l2.3-0.2c0.8,0,1.1-0.6,1.2-0.8L8,5.4l1.1,2.1c0.2,0.4,0.5,0.7,0.9,0.9c0.1,0,0.1,0,0.2,0.1l2.5,0.3L10.9,10.4z M1.9,3.4c0.3-0.3,0.7-0.3,1,0l1.4,1.4c0.3,0.3,0.3,0.7,0,1C4.2,5.9,4,6,3.8,6S3.5,5.9,3.3,5.8L1.9,4.4C1.6,4.1,1.6,3.7,1.9,3.4z M1.1,3.3c-0.2,0-0.4-0.1-0.5-0.2c-0.3-0.3-0.3-0.7,0-1c0.3-0.3,0.7-0.3,1,0l0,0c0.3,0.3,0.3,0.7,0,1C1.4,3.2,1.3,3.3,1.1,3.3z M11.7,5.8c-0.3-0.3-0.3-0.7,0-1l0.4-0.4c0.3-0.3,0.7-0.3,1,0c0.3,0.3,0.3,0.7,0,1l-0.4,0.4C12.5,5.9,12.3,6,12.2,6C12,6,11.8,5.9,11.7,5.8z M15.4,3L15.4,3C15.4,3.1,15.3,3.1,15.4,3c-0.1,0.1-0.1,0.1-0.1,0.1l-0.9,0.9c-0.1,0.1-0.3,0.2-0.5,0.2s-0.4-0.1-0.5-0.2c-0.3-0.3-0.3-0.7,0-1l0.9-0.9c0,0,0,0,0.1,0c0,0,0,0,0-0.1c0.3-0.3,0.7-0.3,1,0C15.7,2.3,15.7,2.8,15.4,3z M7.3,1.8V0.7C7.3,0.3,7.6,0,8,0s0.7,0.3,0.7,0.7v1.1c0,0.4-0.3,0.7-0.7,0.7S7.3,2.2,7.3,1.8z"
          />
        </Icon>
      );
    case IconTypeE.sort:
      return (
        <Icon viewBox="0 0 16 16">
          <path
            fill={color}
            d="M6.7,11.5l-2.1,2.1V0.8c0-0.4-0.3-0.6-0.6-0.6S3.3,0.4,3.3,0.8v12.9l-2.1-2.1c-0.3-0.3-0.7-0.3-0.9,0s-0.3,0.7,0,0.9l3.1,3.1c0.1,0.1,0.3,0.2,0.5,0.2c0.2,0,0.3-0.1,0.5-0.2l3.2-3.2c0.3-0.3,0.3-0.7,0-0.9S6.9,11.3,6.7,11.5z M12.2,7.8H6.3c-0.4,0-0.6,0.3-0.6,0.6S6,9.1,6.3,9.1h5.9c0.4,0,0.7-0.3,0.7-0.7S12.5,7.8,12.2,7.8z M14.7,4.7H6.3C5.9,4.7,5.7,5,5.7,5.3S6,5.9,6.3,5.9h8.5c0.4,0,0.7-0.3,0.7-0.6S15.1,4.7,14.7,4.7z M6.3,2.8h8.5c0.4,0,0.7-0.3,0.7-0.6s-0.3-0.6-0.7-0.6H6.3c-0.4,0-0.6,0.3-0.6,0.6S5.9,2.8,6.3,2.8z"
          />
        </Icon>
      );
    case IconTypeE.share:
      return (
        <Icon viewBox="0 0 16 16">
          <path
            fill={color}
            d="M15.5,7.5L9.3,1.3C9.2,1.1,9.1,1.1,8.9,1c-0.2,0-0.3,0-0.4,0C8.3,1.1,8.2,1.2,8.1,1.4S8,1.6,8,1.8v2.7C5.9,4.7,3.9,5.7,2.5,7.3C1,8.9,0.3,10.9,0.2,13v1.2c0,0.2,0.1,0.3,0.1,0.4c0.1,0.1,0.2,0.2,0.4,0.3c0.2,0.1,0.3,0.1,0.5,0c0.2,0,0.3-0.1,0.4-0.3c0.8-0.9,1.7-1.6,2.7-2.2c1-0.5,2.2-0.9,3.4-1c0,0,0.1,0,0.3,0v2.7c0,0.2,0,0.3,0.1,0.4c0.1,0.1,0.2,0.2,0.3,0.3C8.6,15,8.8,15,8.9,15c0.2,0,0.3-0.1,0.4-0.2l6.2-6.2c0.1-0.1,0.1-0.2,0.2-0.3c0-0.1,0.1-0.2,0.1-0.3c0-0.1,0-0.2-0.1-0.3C15.7,7.6,15.6,7.5,15.5,7.5z M9.6,12.3v-1.6c0-0.1,0-0.2-0.1-0.3c0-0.1-0.1-0.2-0.2-0.3C9.3,10.1,9.2,10,9.1,10C9,10,8.9,9.9,8.8,9.9c-0.2,0-1,0-1.2,0.1c-2.1,0.2-4.1,1-5.7,2.3C2,10.6,2.8,9,4.1,7.8c1.3-1.1,2.9-1.8,4.7-1.8C8.9,6.1,9,6,9.1,6c0.1,0,0.2-0.1,0.3-0.2c0.1-0.1,0.1-0.2,0.2-0.3c0-0.1,0.1-0.2,0.1-0.3V3.7L13.9,8L9.6,12.3z"
          />
        </Icon>
      );
    case IconTypeE.filter:
      return (
        <Icon viewBox="0 0 16 16">
          <path
            fill={color}
            d="M14.7,0.2H1.3C0.6,0.2,0,0.8,0,1.5v1.7c0,0.4,0.2,0.7,0.4,1L5.7,9v5.5c0,0.5,0.2,0.9,0.6,1.1c0.2,0.1,0.4,0.2,0.7,0.2c0.2,0,0.4,0,0.6-0.1l1.8-0.9c0.4-0.2,0.7-0.7,0.7-1.2V9.1l5.5-4.9c0.3-0.2,0.4-0.6,0.4-1V1.5C16,0.8,15.4,0.2,14.7,0.2z M14.7,3.2l-5.6,5C8.9,8.3,8.8,8.6,8.8,8.8v4.8L7,14.5V8.9c0.1-0.3,0-0.6-0.2-0.7l-5.5-5V1.5h13.4V3.2z"
          />
        </Icon>
      );
    case IconTypeE.filterFilled:
      return (
        <Icon viewBox="0 0 16 16">
          <path
            fill={color}
            d="M14.7,0.2H1.3C0.6,0.2,0,0.8,0,1.5v1.7c0,0.4,0.2,0.7,0.4,1L5.7,9v5.5c0,0.5,0.2,0.9,0.6,1.1c0.2,0.1,0.4,0.2,0.7,0.2c0.2,0,0.4,0,0.6-0.1l1.8-0.9c0.4-0.2,0.7-0.7,0.7-1.2V9.1l5.5-4.9C15.9,4,16,3.6,16,3.2V1.5C16,0.8,15.4,0.2,14.7,0.2z"
          />
        </Icon>
      );
    case IconTypeE.folder:
      return (
        <Icon viewBox="0 0 16 16">
          <path
            fill={color}
            d="M15.4,3.2c-0.4-0.4-0.9-0.6-1.5-0.6H8.4L8.2,1.9c-0.1-0.4-0.4-0.8-0.8-1C7.1,0.6,6.6,0.5,6.2,0.5H2.1C1.6,0.5,1,0.7,0.6,1.1C0.2,1.5,0,2,0,2.6v10.8c0,0.6,0.2,1.1,0.6,1.5c0.4,0.4,0.9,0.6,1.5,0.6h11.8c0.6,0,1.1-0.2,1.5-0.6c0.4-0.4,0.6-0.9,0.6-1.5V4.7C16,4.1,15.8,3.6,15.4,3.2z M14.6,13.4c0,0.2-0.1,0.4-0.2,0.5s-0.3,0.2-0.5,0.2H2.1c-0.2,0-0.4-0.1-0.5-0.2c-0.1-0.1-0.2-0.3-0.2-0.5V2.6c0-0.2,0.1-0.4,0.2-0.5C1.8,2,1.9,1.9,2.1,1.9h4.1c0.1,0,0.3,0,0.4,0.1c0.1,0.1,0.2,0.2,0.3,0.3l0.4,1.2c0,0.1,0.1,0.3,0.3,0.3S7.8,4,7.9,4h6c0.2,0,0.4,0.1,0.5,0.2c0.1,0.1,0.2,0.3,0.2,0.5V13.4z"
          />
        </Icon>
      );
    case IconTypeE.wallet:
      return (
        <Icon viewBox="0 0 16 16">
          <path
            fill={color}
            d="M13.6,4h-0.8V3.2c0-0.7-0.3-1.3-0.7-1.7c-0.5-0.5-1.1-0.7-1.7-0.7h-8c-0.7,0-1.3,0.3-1.7,0.7C0.3,2,0,2.6,0,3.2v9.6c0,0.7,0.3,1.3,0.7,1.7c0.5,0.5,1.1,0.7,1.7,0.7h11.2c0.7,0,1.3-0.3,1.7-0.7c0.5-0.5,0.7-1.1,0.7-1.7V6.4c0-0.7-0.3-1.3-0.7-1.7C14.9,4.3,14.3,4,13.6,4z M2.4,2.4h8c0.2,0,0.4,0.1,0.5,0.3c0.1,0.1,0.3,0.3,0.3,0.5V4H2.4C2.2,4,2,3.9,1.9,3.8C1.7,3.6,1.6,3.4,1.6,3.2c0-0.2,0.1-0.4,0.3-0.5C2,2.5,2.2,2.4,2.4,2.4z M14.4,10.4h-0.8c-0.2,0-0.4-0.1-0.5-0.3c-0.1-0.1-0.3-0.3-0.3-0.5c0-0.2,0.1-0.4,0.3-0.5c0.1-0.1,0.3-0.3,0.5-0.3h0.8V10.4z M14.4,7.2h-0.8c-0.7,0-1.3,0.3-1.7,0.7c-0.5,0.5-0.7,1.1-0.7,1.7c0,0.6,0.3,1.3,0.7,1.7c0.5,0.5,1.1,0.7,1.7,0.7h0.8v0.8c0,0.2-0.1,0.4-0.3,0.5c-0.2,0.1-0.3,0.3-0.5,0.3H2.4c-0.2,0-0.4-0.1-0.5-0.3c-0.1-0.1-0.3-0.3-0.3-0.5V5.5c0.3,0.1,0.5,0.1,0.8,0.1h11.2c0.2,0,0.4,0.1,0.5,0.3c0.1,0.1,0.3,0.3,0.3,0.5C14.4,6.4,14.4,7.2,14.4,7.2z"
          />
        </Icon>
      );
    case IconTypeE.stop:
      return (
        <Icon viewBox="0 0 16 16">
          <path
            fill={color}
            d="M8,0C3.6,0,0,3.6,0,8c0,4.4,3.6,8,8,8c4.4,0,8-3.6,8-8C16,3.6,12.4,0,8,0z M12,13.1c-1.1,0.9-2.5,1.4-4,1.4c-3.6,0-6.5-2.9-6.5-6.5c0-1.4,0.5-2.8,1.4-4L12,13.1z M4.1,2.9C5.3,2,6.6,1.5,8,1.5c3.6,0,6.5,2.9,6.5,6.5c0,1.4-0.5,2.7-1.4,3.9L4.1,2.9z"
          />
        </Icon>
      );
    case IconTypeE.chatBubble:
      return (
        <Icon viewBox="0 0 16 16">
          <path
            fill={color}
            d="M15.9,12.5l-1.3-3c-0.1-0.2-0.2-0.3-0.4-0.4C14,9,13.8,9,13.6,9.1c-0.2,0.1-0.3,0.2-0.4,0.4c-0.1,0.2-0.1,0.4,0,0.6l0.5,1.2L12,10.6c-0.2-0.1-0.4-0.1-0.7,0c-0.7,0.3-1.5,0.5-2.3,0.5c-2.9,0-5.3-2.1-5.3-4.8S6.1,1.6,9,1.6c2.9,0,5.3,2.1,5.3,4.8c0,0.5,0,0.6,0,0.8c-0.1,0.2-0.1,0.4,0,0.6c0.1,0.2,0.3,0.3,0.5,0.4c0.4,0.1,0.9-0.1,1-0.5c0.1-0.4,0.1-0.6,0.1-1.2C15.9,2.8,12.8,0,9,0C5.4,0,2.4,2.6,2.2,5.9C0.8,6.9,0,8.4,0,10c0,1,0.3,2,0.9,2.9l-0.9,2c-0.1,0.3-0.1,0.6,0.2,0.9C0.4,15.9,0.6,16,0.8,16c0.1,0,0.2,0,0.3-0.1l2.4-1.1c0.7,0.3,1.4,0.4,2.2,0.4c2.1,0,4-1.1,5-2.8c0.4-0.1,0.7-0.2,1-0.3l3.2,1.4c0.3,0.1,0.6,0.1,0.9-0.2C16,13.2,16.1,12.8,15.9,12.5z M2.6,13.1c0.1-0.3,0.1-0.6-0.1-0.8c-0.6-0.7-0.9-1.4-0.9-2.2c0-0.8,0.3-1.5,0.8-2.1c0.7,2.7,3.2,4.6,6.2,4.8c-0.8,0.7-1.8,1-2.9,1c-0.6,0-1.3-0.1-1.9-0.4c-0.1,0-0.2-0.1-0.3-0.1c-0.1,0-0.2,0-0.3,0.1l-0.9,0.4L2.6,13.1z M7.4,6.3c0,0.4-0.4,0.8-0.8,0.8c-0.4,0-0.8-0.4-0.8-0.8c0-0.4,0.4-0.8,0.8-0.8C7.1,5.5,7.4,5.9,7.4,6.3z M9.9,6.3c0,0.4-0.4,0.8-0.8,0.8c-0.4,0-0.8-0.4-0.8-0.8c0-0.4,0.4-0.8,0.8-0.8C9.5,5.5,9.9,5.9,9.9,6.3z M12.4,6.3c0,0.4-0.4,0.8-0.8,0.8s-0.8-0.4-0.8-0.8c0-0.4,0.4-0.8,0.8-0.8S12.4,5.9,12.4,6.3z"
          />
        </Icon>
      );
    case IconTypeE.table:
      return (
        <Icon viewBox="0 0 16 16">
          <path
            fill={color}
            d="M15.7,0.3C15.6,0.1,15.4,0,15.2,0H0.8C0.6,0,0.4,0.1,0.3,0.3C0.1,0.4,0,0.6,0,0.8v14.4c0,0.2,0.1,0.4,0.3,0.5C0.4,15.9,0.6,16,0.8,16h14.4c0.2,0,0.4-0.1,0.5-0.3c0.1-0.1,0.3-0.3,0.3-0.5V0.8C16,0.6,15.9,0.4,15.7,0.3z M1.6,6.7h5.6v3H1.6V6.7z M8.8,6.7h5.6v3H8.8C8.8,9.7,8.8,6.7,8.8,6.7z M14.4,1.6v3.5H1.6V1.6H14.4z M1.6,11.3h5.6v3.1H1.6V11.3z M8.8,14.4v-3.1h5.6v3.1C14.4,14.4,8.8,14.4,8.8,14.4z"
          />
        </Icon>
      );
    case IconTypeE.thumbs:
      return (
        <Icon viewBox="0 0 16 16">
          <path
            fill={color}
            d="M15.4,6.5c-0.2-0.3-0.5-0.5-0.8-0.6c-0.3-0.1-0.7-0.2-1-0.2H9.9l0.4-1.1c0.2-0.5,0.2-1,0.2-1.5c-0.1-0.5-0.3-1-0.6-1.4C9.7,1.3,9.3,1,8.8,0.7c-0.5-0.2-1-0.4-1.5-0.4c-0.2,0-0.3,0-0.4,0.1C6.7,0.6,6.6,0.7,6.6,0.8L4.3,5.7H2.4c-0.6,0-1.2,0.2-1.7,0.7C0.2,6.8,0,7.4,0,8v5.3c0,0.6,0.3,1.2,0.7,1.6c0.5,0.4,1.1,0.7,1.7,0.7h10.2c0.6,0,1.1-0.2,1.5-0.5c0.4-0.3,0.7-0.8,0.8-1.3l1-5.3c0.1-0.3,0-0.7,0-1C15.8,7.1,15.7,6.8,15.4,6.5z M4,14.1H2.4c-0.2,0-0.4-0.1-0.6-0.2c-0.2-0.1-0.2-0.3-0.2-0.5V8c0-0.2,0.1-0.4,0.2-0.5C2,7.3,2.2,7.2,2.4,7.2H4V14.1z M14.4,8.1l-1,5.3c0,0.2-0.1,0.3-0.3,0.5c-0.1,0.1-0.3,0.2-0.5,0.2h-7V6.6L7.8,2C8,2,8.2,2.1,8.4,2.3c0.2,0.1,0.3,0.3,0.4,0.5C8.9,3,9,3.2,9,3.4c0,0.2,0,0.4-0.1,0.7L8.5,5.2C8.4,5.4,8.3,5.7,8.4,5.9c0,0.2,0.1,0.5,0.3,0.7C8.8,6.8,9,6.9,9.2,7.1c0.2,0.1,0.5,0.2,0.7,0.2h3.6c0.1,0,0.2,0,0.3,0.1c0.1,0,0.2,0.1,0.3,0.2c0.1,0.1,0.1,0.2,0.2,0.3C14.4,7.9,14.4,8,14.4,8.1z"
          />
        </Icon>
      );
    case IconTypeE.eye:
      return (
        <Icon viewBox="0 0 16 16">
          <path
            fill={color}
            d="M15.9,7.6C14.3,4.1,11.3,2,8,2S1.7,4.2,0.1,7.7C0,7.8,0,7.9,0,8c0,0.1,0,0.2,0.1,0.3C1.7,11.8,4.7,14,8,14s6.3-2.2,7.9-5.7C16,8.2,16,8.1,16,8C16,7.9,16,7.7,15.9,7.6z M8,12.4c-2.6,0-4.9-1.7-6.3-4.4C3.1,5.2,5.4,3.5,8,3.5s4.9,1.7,6.3,4.4C12.9,10.7,10.6,12.4,8,12.4z M8,4.9c-0.6,0-1.3,0.2-1.7,0.5C5.7,5.8,5.3,6.2,5,6.8C4.8,7.3,4.7,7.9,4.8,8.5S5.2,9.6,5.7,10s1,0.7,1.6,0.8s1.3,0.1,1.9-0.2s1.1-0.6,1.4-1.1c0.3-0.5,0.5-1.1,0.5-1.6c0-0.8-0.3-1.6-0.9-2.1C9.7,5.2,8.9,4.9,8,4.9z M8,9.4c-0.3,0-0.6-0.1-0.9-0.2C6.9,9,6.7,8.8,6.5,8.5c-0.1-0.3-0.1-0.6,0-0.9S6.7,7,7,6.8c0.2-0.2,0.5-0.4,0.8-0.4c0.3-0.1,0.6,0,0.9,0.1C9,6.6,9.2,6.8,9.4,7.1c0.2,0.2,0.3,0.6,0.3,0.8c0,0.4-0.2,0.8-0.5,1.1C8.8,9.2,8.4,9.4,8,9.4z"
          />
        </Icon>
      );
    case IconTypeE.eyeStrike:
      return (
        <Icon viewBox="0 0 16 16">
          <path
            fill={color}
            d="M15.9,7.6c-0.6-1.3-1.4-2.5-2.4-3.3l-1.1,1.1C13.2,6.1,13.8,7,14.3,8c-1.4,2.8-3.8,4.5-6.3,4.5c-0.8,0-1.7-0.2-2.4-0.5l-1.3,1.2c1.1,0.6,2.4,0.9,3.7,0.9c3.3,0,6.3-2.2,7.9-5.7C16,8.2,16,8.1,16,8C16,7.9,16,7.8,15.9,7.6z M2.4,11.7l1.2-1.1C2.9,9.9,2.2,9,1.7,8C3.1,5.2,5.4,3.5,8,3.5c0.9,0,1.7,0.2,2.6,0.6l1.2-1.1c-1.1-0.6-2.4-1-3.8-1C4.7,2,1.7,4.2,0.1,7.7C0,7.8,0,7.9,0,8c0,0.1,0,0.2,0.1,0.3C0.7,9.7,1.5,10.8,2.4,11.7z M2,14.7L15.3,2.3c0.3-0.3,0.3-0.8,0-1.1c-0.3-0.3-0.8-0.3-1.1,0L0.9,13.7c-0.3,0.3-0.3,0.8,0,1.1C1,14.9,1.2,15,1.5,15C1.6,15,1.8,14.9,2,14.7z M6.4,8L5.1,9.2C5,9,4.9,8.8,4.8,8.5C4.7,8,4.8,7.3,5,6.8c0.3-0.6,0.7-1,1.2-1.4C6.7,5.1,7.4,4.9,8,4.9c0.5,0,0.9,0.1,1.3,0.3L8.1,6.4c0,0-0.1,0-0.1,0C7.1,6.4,6.4,7.1,6.4,8C6.4,8,6.4,8,6.4,8z M11.2,7.9c0,0.6-0.2,1.1-0.5,1.6c-0.3,0.5-0.8,0.9-1.4,1.1S7.9,11,7.3,10.9c-0.2-0.1-0.3-0.1-0.5-0.1l1.3-1.3c0,0,0.1,0,0.1,0C9,9.3,9.6,8.8,9.7,8.1c0,0,0,0,0-0.1L11,6.8C11.1,7.1,11.2,7.5,11.2,7.9z"
          />
        </Icon>
      );
    case IconTypeE.pptx:
      return (
        <Icon viewBox="0 0 16 16">
          <path
            fill={color}
            d="M6.2,7.5c-0.2,0-0.3,0-0.4,0.1v1.7c0.1,0,0.2,0,0.3,0c0.5,0,0.8-0.4,0.8-1C6.9,7.8,6.7,7.5,6.2,7.5z M15,5.9h-0.4V4.7c0,0,0,0,0,0c0-0.1,0-0.2-0.1-0.2L11,0.1c0,0,0,0,0,0c0,0,0,0-0.1-0.1c0,0,0,0,0,0c0,0,0,0-0.1,0c0,0,0,0,0,0c0,0-0.1,0-0.1,0H2.2C1.8,0,1.4,0.3,1.4,0.8v5.2H1C0.5,5.9,0,6.4,0,7v5.4c0,0.6,0.5,1.1,1,1.1h0.4v1.7c0,0.4,0.3,0.8,0.7,0.8h11.7c0.4,0,0.7-0.3,0.7-0.8v-1.7H15c0.6,0,1-0.5,1-1.1V7C16,6.4,15.5,5.9,15,5.9z M2.2,0.8h8.2v3.9c0,0.2,0.2,0.4,0.4,0.4h3.1v0.9H2.2V0.8z M8.1,7.7V6.8h3.2v0.8h-1.1v4.7H9.3V7.7H8.1z M7.9,8.3c0,0.6-0.1,1.1-0.4,1.4c-0.3,0.4-0.8,0.6-1.3,0.6c-0.1,0-0.2,0-0.3,0v2.1H4.9V6.9c0.3-0.1,0.7-0.1,1.3-0.1c0.6,0,1,0.2,1.3,0.5C7.7,7.6,7.9,7.8,7.9,8.3z M1.3,12.4V6.9C1.6,6.8,2,6.8,2.6,6.8c0.6,0,1,0.2,1.3,0.5c0.3,0.3,0.4,0.5,0.4,1.1c0,0.6-0.1,1.1-0.4,1.4c-0.3,0.4-0.8,0.6-1.3,0.6c-0.1,0-0.2,0-0.3,0v2.1L1.3,12.4L1.3,12.4z M13.8,15.1H2.2v-1.5h11.7L13.8,15.1L13.8,15.1z M14.1,12.4l-0.4-1.1c-0.2-0.4-0.3-0.7-0.4-1h0c-0.1,0.3-0.2,0.6-0.3,1l-0.3,1.1h-1.1l1.2-3l-1.2-2.6h1.1l0.4,0.8c0.1,0.4,0.2,0.6,0.3,1h0c0.1-0.4,0.2-0.6,0.3-1l0.4-0.8h1.1L14,9.4l1.2,3H14.1z M3.4,8.4c0-0.5-0.3-0.9-0.7-0.9c-0.2,0-0.3,0-0.4,0.1v1.7c0.1,0,0.2,0,0.3,0C3.1,9.3,3.4,9,3.4,8.4z"
          />
        </Icon>
      );
    case IconTypeE.igPost:
      return (
        <Icon viewBox="0 0 16 16">
          <path
            fill={color}
            d="M12.7,8C12.3,8,12,8.3,12,8.7V14c0,0.4-0.3,0.7-0.7,0.7H2c-0.4,0-0.7-0.3-0.7-0.7V4.7C1.3,4.3,1.6,4,2,4h5.3C7.7,4,8,3.7,8,3.3S7.7,2.7,7.3,2.7H2c-1.1,0-2,0.9-2,2V14c0,1.1,0.9,2,2,2h9.3c1.1,0,2-0.9,2-2V8.7C13.3,8.3,13,8,12.7,8z M6.3,7.4c0,0-0.1,0.1-0.1,0.2L5.7,9.9c0,0.1,0,0.2,0.1,0.3c0.1,0.1,0.1,0.1,0.2,0.1c0,0,0,0,0.1,0l2.4-0.5c0.1,0,0.1,0,0.2-0.1l5.3-5.3l-2.4-2.4L6.3,7.4z M15.5,0.5c-0.6-0.6-1.7-0.6-2.4,0l-0.9,0.9l2.4,2.4l0.9-0.9C15.8,2.5,16,2.1,16,1.7C16,1.2,15.8,0.8,15.5,0.5z"
          />
        </Icon>
      );
    case IconTypeE.igVideo:
      return (
        <Icon viewBox="0 0 16 16">
          <path
            fill={color}
            d="M14.9,6.5c-0.3-0.5-0.6-0.8-1.1-1.1V5.3L5.2,0.4C4.8,0.1,4.2,0,3.7,0C3.2,0,2.6,0.1,2.2,0.4S1.3,1.1,1.1,1.5C0.8,2,0.7,2.5,0.7,3.1V13c0,0.8,0.3,1.6,0.9,2.1S2.9,16,3.7,16c0.5,0,1.1-0.1,1.5-0.4l8.6-4.9c0.5-0.3,0.8-0.7,1.1-1.1c0.3-0.5,0.4-1,0.4-1.5S15.2,7,14.9,6.5z M13.4,8.6c-0.1,0.2-0.3,0.4-0.5,0.5v0l-8.6,5c-0.2,0.1-0.4,0.2-0.6,0.2c-0.2,0-0.4-0.1-0.6-0.2c-0.2-0.1-0.4-0.3-0.5-0.5c-0.1-0.2-0.2-0.4-0.2-0.6V3c0-0.2,0.1-0.4,0.2-0.6c0.1-0.2,0.3-0.4,0.5-0.5c0.2-0.1,0.4-0.2,0.6-0.2c0.2,0,0.4,0.1,0.6,0.2l8.6,5c0.2,0.1,0.4,0.3,0.5,0.5c0.1,0.2,0.2,0.4,0.2,0.6C13.6,8.2,13.5,8.4,13.4,8.6z"
          />
        </Icon>
      );
    case IconTypeE.igStory:
      return (
        <Icon viewBox="0 0 16 16">
          <path
            fill={color}
            d="M7.6,0.2c-0.2,0.3-0.2,0.4,0,0.7c0.1,0.2,0.3,0.2,1,0.3c1.9,0.2,3.6,1.1,4.8,2.5c0.5,0.6,1.1,1.9,1.4,2.7c0.2,0.8,0.2,2.6,0,3.4c-0.4,1.4-1.4,3-2.5,3.7c-1,0.8-1.2,1-0.8,1.3c0.3,0.3,0.5,0.2,1.1-0.2c1.4-1,2.5-2.4,3-4C15.9,9.7,16,9,16,8c0-2.1-0.7-3.9-2.1-5.4C12.5,1.1,10.6,0.2,8.6,0C7.8,0,7.8,0,7.6,0.2z M2.5,2.1C2.3,2.5,2.3,2.6,2.5,2.9c0.2,0.3,0.6,0.3,0.9,0c0.3-0.3,0.3-0.6,0-0.8C3.1,1.8,2.8,1.8,2.5,2.1z M1,4.4C0.7,4.5,0.2,5.8,0,6.9C0,7.4,0,7.5,0.2,7.6c0.5,0.5,0.8,0.1,1-0.8c0.1-0.4,0.2-1,0.4-1.3c0.2-0.5,0.2-0.6,0.1-0.8C1.5,4.4,1.3,4.3,1,4.4z M7.4,5.9v1.6H5.8H4.3v0.6v0.6h1.6h1.6v1.6v1.6H8h0.6v-1.6V8.6l1.6,0l1.6,0V8.1V7.5l-1.6,0l-1.6,0V5.9V4.4H8H7.4V5.9z M0.3,9.4c-0.1,0.2-0.2,0.2-0.1,0.7c0.1,0.6,0.7,1.8,1.1,2.4C1.8,13.2,2.6,14,2.8,14c0.3,0,0.6-0.2,0.6-0.5c0-0.1-0.2-0.5-0.6-0.9C2.2,11.8,1.7,11,1.4,10C1.2,9.7,1.1,9.4,1,9.3C0.8,9.2,0.5,9.3,0.3,9.4z M4.1,14.2c-0.2,0.2-0.2,0.6,0,0.8c0.2,0.2,1.1,0.6,1.9,0.8c1.4,0.4,3.7,0.3,4.1-0.1c0.2-0.3,0.2-0.6-0.1-0.8c-0.2-0.1-0.3-0.1-0.6,0c-1.2,0.3-3,0-4.2-0.5C4.5,14,4.3,14,4.1,14.2z"
          />
        </Icon>
      );
    case IconTypeE.csv:
      return (
        <Icon viewBox="0 0 16 16">
          <path
            fill={color}
            d="M15,5.9h-0.4V4.5c0,0,0,0,0,0c0-0.1,0-0.2-0.1-0.2L11,0.1c0,0,0,0,0,0c0,0,0,0-0.1-0.1c0,0,0,0,0,0c0,0,0,0-0.1,0c0,0,0,0,0,0c0,0-0.1,0-0.1,0H2.2C1.8,0,1.4,0.3,1.4,0.7v5.2H1c-0.6,0-1,0.5-1,1v5.4c0,0.6,0.5,1,1,1h0.4v1.9c0,0.4,0.3,0.7,0.7,0.7h11.7c0.4,0,0.7-0.3,0.7-0.7v-1.9H15c0.6,0,1-0.5,1-1V6.9C16,6.3,15.5,5.9,15,5.9z M2.4,0.7h8v3.7c0,0.2,0.2,0.4,0.4,0.4h2.9v1.1H2.4V0.7z M7.5,9.8C6.6,9.5,6,9,6,8.2c0-0.9,0.8-1.6,2-1.6c0.6,0,1,0.1,1.3,0.3l-0.3,1C8.9,7.8,8.5,7.6,8,7.6c-0.5,0-0.8,0.2-0.8,0.5c0,0.3,0.3,0.5,1,0.8c0.9,0.4,1.4,0.9,1.4,1.6c0,0.9-0.7,1.7-2.1,1.7c-0.6,0-1.2-0.2-1.5-0.3l0.2-1C6.5,11,7,11.2,7.5,11.2c0.5,0,0.8-0.2,0.8-0.6C8.4,10.2,8.1,10.1,7.5,9.8z M1.3,9.5c0-1.8,1.3-2.9,2.9-2.9c0.6,0,1.1,0.1,1.3,0.2l-0.2,1C5,7.7,4.6,7.6,4.2,7.6c-0.9,0-1.7,0.6-1.7,1.8c0,1.1,0.6,1.8,1.7,1.8c0.4,0,0.8-0.1,1-0.2l0.2,1c-0.2,0.1-0.7,0.2-1.4,0.2C2.2,12.2,1.3,11,1.3,9.5z M13.7,15.1H2.4v-1.7h11.3V15.1z M13.1,12.1h-1.4L10,6.7h1.3L11.9,9c0.2,0.6,0.3,1.3,0.5,1.9h0c0.1-0.7,0.3-1.3,0.5-1.9l0.7-2.3h1.3L13.1,12.1z"
          />
        </Icon>
      );
    case IconTypeE.xlsx:
      return (
        <Icon viewBox="0 0 16 16">
          <path
            fill={color}
            d="M15,5.9h-0.4V4.5c0,0,0,0,0,0c0-0.1,0-0.2-0.1-0.2L11,0.1c0,0,0,0,0,0c0,0,0,0-0.1-0.1c0,0,0,0,0,0c0,0,0,0-0.1,0c0,0,0,0,0,0c0,0-0.1,0-0.1,0H2.2C1.8,0,1.4,0.3,1.4,0.7v5.2H1c-0.6,0-1,0.5-1,1v5.4c0,0.6,0.5,1,1,1h0.4v1.9c0,0.4,0.3,0.7,0.7,0.7h11.7c0.4,0,0.7-0.3,0.7-0.7v-1.9H15c0.6,0,1-0.5,1-1V6.9C16,6.3,15.5,5.9,15,5.9z M2.4,0.7h8v3.7c0,0.2,0.2,0.4,0.4,0.4h2.9v1.1H2.4V0.7z M9.5,10C8.7,9.7,8.3,9.2,8.3,8.4c0-0.9,0.6-1.7,1.7-1.7c0.5,0,0.9,0.1,1.1,0.3l-0.2,1c-0.2-0.1-0.5-0.3-0.9-0.3S9.3,8,9.3,8.3c0,0.4,0.3,0.5,0.8,0.8c0.8,0.4,1.2,0.9,1.2,1.6c0,0.9-0.6,1.7-1.8,1.7c-0.5,0-1-0.2-1.3-0.3l0.2-1c0.3,0.2,0.7,0.3,1.1,0.3c0.5,0,0.7-0.2,0.7-0.6C10.2,10.5,10,10.3,9.5,10z M7.8,11.3v1H5V6.8h1v4.4H7.8z M2.2,11.3l-0.4,1H0.6l1.3-2.8L0.7,6.8h1.2l0.4,1c0.1,0.3,0.2,0.6,0.3,0.9h0c0.1-0.4,0.2-0.6,0.3-0.9l0.4-1h1.1L3.1,9.5l1.3,2.8H3.3l-0.4-1c-0.2-0.4-0.3-0.7-0.4-1h0C2.4,10.7,2.3,10.9,2.2,11.3z M13.7,15.1H2.4v-1.7h11.3V15.1z M14.3,12.3L14.3,12.3L14.3,12.3l-0.4-1c-0.2-0.4-0.3-0.7-0.4-1h0c-0.1,0.3-0.2,0.6-0.3,1l-0.4,1h-1.1l1.3-2.8l-1.2-2.7h1.2l0.4,1c0.1,0.3,0.2,0.6,0.3,0.9h0c0.1-0.4,0.2-0.6,0.3-0.9l0.4-1h1.1l-1.3,2.7l1.3,2.8H14.3z"
          />
        </Icon>
      );
    case IconTypeE.upload:
      return (
        <Icon viewBox="0 0 16 16">
          <path
            fill={color}
            d="M3.3,4.2C3.6,2,5.5,0.4,7.8,0.4c2.3,0,4.2,1.6,4.5,3.8l0.1,0c1.8,0,3.2,1.4,3.2,3.2c0,0.1,0,0.3,0,0.4c-0.4-0.4-0.8-0.8-1.3-1.1c-0.3-0.8-1-1.4-1.9-1.4l-0.6,0c-0.3,0-0.6-0.3-0.6-0.6C11.1,3,9.6,1.6,7.8,1.6C6,1.6,4.5,3,4.4,4.8c0,0.3-0.3,0.6-0.6,0.6l-0.6,0c-1.1,0-2,0.9-2,2s0.9,2,2,2h3.5c-0.1,0.4-0.2,0.8-0.3,1.2H3.2C1.4,10.6,0,9.2,0,7.4S1.4,4.2,3.3,4.2L3.3,4.2z M11.6,6.8c-2.4,0-4.4,2-4.4,4.4s2,4.4,4.4,4.4c2.4,0,4.4-2,4.4-4.4S14,6.8,11.6,6.8z M13.9,11.1c-0.2,0.2-0.4,0.2-0.6,0L12,9.8v3.8c0,0.2-0.2,0.4-0.4,0.4c-0.2,0-0.4-0.2-0.4-0.4V9.8l-1.3,1.3c-0.2,0.2-0.4,0.2-0.6,0c-0.2-0.2-0.2-0.4,0-0.6l2-2c0.2-0.2,0.4-0.2,0.6,0l2,2C14,10.7,14,10.9,13.9,11.1z"
          />
        </Icon>
      );
    case IconTypeE.reportingPrivate:
      return (
        <Icon viewBox="0 0 16 16">
          <path
            fill={color}
            d="M11.2,6.4c-0.6,0-1.1,0.1-1.7,0.3l0.7-1.1c0.1-0.2,0.1-0.4,0-0.6C10.2,4.8,10,4.7,9.8,4.7H6.6H6.3l0.1-0.2l1.7-3.7c0.1-0.2,0.1-0.4,0-0.5C7.9,0.2,7.8,0.1,7.6,0.1H3.5C3.2,0.1,3,0.2,3,0.4L0,8.2C0,8.3,0,8.5,0.1,8.7c0.1,0.1,0.3,0.2,0.4,0.2h3.8h0.2l0,0.2L3,14.9c-0.1,0.3,0.1,0.5,0.3,0.6c0.1,0,0.1,0,0.2,0c0.2,0,0.4-0.1,0.5-0.3l2.5-3.8c0.2,2.5,2.2,4.4,4.7,4.4c2.6,0,4.8-2.1,4.8-4.8S13.9,6.4,11.2,6.4z M4.8,12.3L5,11.4l0.7-2.9c0-0.2,0-0.3-0.1-0.5C5.4,7.9,5.3,7.9,5.1,7.9H1.5H1.3l0.1-0.2l2.4-6.5l0-0.1h0.1h2.7h0.2L6.7,1.3L5.1,5C5,5.2,5,5.4,5.1,5.5c0.1,0.2,0.3,0.2,0.5,0.2h3.1h0.3L8.8,6l-3.5,5.5L4.8,12.3z M11.2,15c-2.1,0-3.8-1.7-3.8-3.8s1.7-3.8,3.8-3.8S15,9.1,15,11.2S13.3,15,11.2,15z M9.2,13.1c0,0,0-0.1,0-0.1l1.5-4.2c0-0.1,0.2-0.1,0.4-0.1h0.3c0.2,0,0.3,0,0.4,0.1l1.5,4.2c0,0,0,0.1,0,0.1c0,0,0,0.1-0.1,0.1s-0.1,0-0.2,0h-0.3c-0.1,0-0.2,0-0.2,0c-0.1,0-0.1-0.1-0.1-0.1L12,12.4h-1.5l-0.3,0.8c0,0.1-0.1,0.1-0.3,0.1H9.6C9.3,13.3,9.2,13.2,9.2,13.1z M11.7,11.5l-0.4-1.2c0-0.1,0-0.1-0.1-0.2c0-0.1,0-0.1,0-0.2h0l0,0.1c0,0.1-0.1,0.3-0.1,0.3l-0.4,1.2H11.7z"
          />
        </Icon>
      );
    case IconTypeE.reportingPublic:
      return (
        <Icon viewBox="0 0 16 16">
          <path
            fill={color}
            d="M11.2,6.4c-0.6,0-1.1,0.1-1.7,0.3l0.7-1.1c0.1-0.2,0.1-0.4,0-0.6C10.2,4.8,10,4.7,9.8,4.7H6.6H6.3l0.1-0.2l1.7-3.7c0.1-0.2,0.1-0.4,0-0.5C7.9,0.2,7.8,0.1,7.6,0.1H3.5C3.2,0.1,3,0.2,3,0.4L0,8.2C0,8.3,0,8.5,0.1,8.7c0.1,0.1,0.3,0.2,0.4,0.2h3.8h0.2l0,0.2L3,14.9c-0.1,0.3,0.1,0.5,0.3,0.6c0.1,0,0.1,0,0.2,0c0.2,0,0.4-0.1,0.5-0.3l2.5-3.8c0.2,2.5,2.2,4.4,4.7,4.4c2.6,0,4.8-2.1,4.8-4.8S13.9,6.4,11.2,6.4z M4.8,12.3L5,11.4l0.7-2.9c0-0.2,0-0.3-0.1-0.5C5.4,7.9,5.3,7.9,5.1,7.9H1.5H1.3l0.1-0.2l2.4-6.5l0-0.1h0.1h2.7h0.2L6.7,1.3L5.1,5C5,5.2,5,5.4,5.1,5.5c0.1,0.2,0.3,0.2,0.5,0.2h3.1h0.3L8.8,6l-3.5,5.5L4.8,12.3z M11.2,15c-2.1,0-3.8-1.7-3.8-3.8s1.7-3.8,3.8-3.8S15,9.1,15,11.2S13.3,15,11.2,15z M9.8,13.1l0-4.1c0-0.1,0-0.2,0.1-0.2c0,0,0.1-0.1,0.2-0.1l1.4,0c0.4,0,0.8,0.1,1.1,0.3c0.3,0.2,0.5,0.6,0.5,1.1c0,0.4-0.1,0.7-0.3,0.9c-0.2,0.2-0.4,0.4-0.6,0.4c-0.2,0.1-0.4,0.1-0.6,0.1h-0.7l0,1.5c0,0.1-0.1,0.2-0.4,0.2h-0.2C9.9,13.3,9.8,13.2,9.8,13.1z M11.4,10.7c0.2,0,0.3,0,0.4-0.1c0.1-0.1,0.2-0.2,0.2-0.4c0-0.2-0.1-0.4-0.2-0.5c-0.1-0.1-0.2-0.1-0.4-0.1h-0.6v1.1H11.4z"
          />
        </Icon>
      );
    case IconTypeE.reportingManual:
      return (
        <Icon viewBox="0 0 16 16">
          <path
            fill={color}
            d="M11.2,6.3c-1.6,0-3,0.8-3.8,2L7.8,5l0.3,0l0.1-0.7c0-0.1,0.2-0.2,0.3-0.2c0.2,0,0.2,0.2,0.3,0.3l0,0.1c0,0,0,0,0,0l0,0l0,0c0,0.2,0.1,0.5,0.4,0.6l0.5,0.1l0,0l0.7,0.1c0.1,0,0.1,0,0.2,0c0.7,0,1.3-0.5,1.4-1.2l0.1-0.9h0l0.1-0.9c0.1-0.4,0-0.7-0.3-1c-0.2-0.3-0.5-0.5-0.9-0.5L10,0.7c0,0,0,0-0.1,0L9.4,0.6L9.3,1.3c0,0.1-0.2,0.2-0.3,0.2c-0.2,0-0.2-0.2-0.3-0.3l0.1-0.7L8.3,0.5c0,0,0,0,0,0L7.6,0.3c0,0-0.6-0.1-1.7-0.3C5.3,0,4.3,0,3.2,0.4C2,0.9,0.6,1.7,0.1,3C-0.1,3.2,0,3.5,0.2,3.7c0.2,0.2,0.5,0.2,0.7,0.1C2,3.2,3.1,3.1,4.1,3.1L4,3.8C4,4,4.1,4.3,4.3,4.4l-1.4,9.5c-0.1,0.4,0.1,0.9,0.3,1.2c0.3,0.4,0.7,0.7,1.2,0.7h0c0.1,0,0.2,0,0.3,0c0.4,0,0.8-0.1,1.1-0.4c0.3-0.3,0.6-0.7,0.6-1.1l0.2-1.7c0.7,1.8,2.4,3.1,4.5,3.1c2.6,0,4.8-2.1,4.8-4.8C16,8.5,13.9,6.3,11.2,6.3z M1.8,2.3C3,1.1,5.1,1,5.8,1.1c1,0.1,1.6,0.3,1.6,0.3l0.4,0.1c0,0.2,0.1,0.4,0.2,0.5c0.2,0.3,0.5,0.5,0.9,0.6c0.4,0.1,0.7-0.1,1-0.3C10,2.1,10.1,2,10.2,1.8L11,1.9c0.2,0,0.3,0.2,0.3,0.4l-0.1,0.9l0,0L11,4.1c0,0.2-0.2,0.3-0.4,0.3L9.9,4.2c-0.1-0.5-0.5-1-1.1-1.1h0C8.1,3.1,7.6,3.5,7.4,3.9L5.1,3.6L5.2,3c0-0.2,0-0.4-0.1-0.6C4.9,2.3,4.8,2.2,4.6,2.1C3.7,2,2.6,2,1.8,2.3z M5.5,14.3c0,0.3-0.3,0.6-0.8,0.6c-0.3,0-0.4-0.2-0.5-0.3C4,14.4,3.9,14.2,4,14.1l1.3-9.4l1.5,0.2L5.5,14.3z M11.2,14.9c-2.1,0-3.8-1.7-3.8-3.8c0-2.1,1.7-3.8,3.8-3.8c2.1,0,3.8,1.7,3.8,3.8C15,13.2,13.3,14.9,11.2,14.9z M8.9,13.1V8.9c0-0.1,0-0.1,0.1-0.2c0.1,0,0.2-0.1,0.3-0.1h0.3c0.2,0,0.3,0.1,0.4,0.2l1.1,2l0.1,0.1l0.1-0.1l1.1-1.9c0.1-0.1,0.2-0.2,0.4-0.2h0.3c0.3,0,0.4,0.1,0.4,0.2v4.2c0,0.1-0.1,0.2-0.4,0.2h-0.2c-0.3,0-0.4-0.1-0.4-0.2v-2.7l0,0l-1,1.7c-0.1,0.1-0.1,0.1-0.3,0.1h-0.2c-0.1,0-0.1,0-0.2,0c0,0-0.1-0.1-0.1-0.1l-1-1.7l0,0v2.7c0,0.1-0.1,0.2-0.4,0.2H9.3C9,13.3,8.9,13.2,8.9,13.1z"
          />
        </Icon>
      );
    case IconTypeE.chart:
      return (
        <Icon viewBox="0 0 16 16">
          <path
            fill={color}
            d="M2.2,7.4c0.2,0,0.3-0.1,0.5-0.2L5.8,4l2.2,2.2c0.3,0.3,0.7,0.3,1,0l4-4v1.6c0,0.4,0.3,0.7,0.7,0.7c0.4,0,0.7-0.3,0.7-0.7V0.7c0-0.4-0.3-0.7-0.7-0.7c0,0,0,0,0,0c0,0,0,0-0.1,0h-3.1c-0.4,0-0.7,0.3-0.7,0.7s0.3,0.7,0.7,0.7H12L8.6,4.8L6.3,2.6c-0.3-0.3-0.7-0.3-1,0L1.7,6.2c-0.3,0.3-0.3,0.7,0,1C1.8,7.3,2,7.4,2.2,7.4z"
          />
          <path
            fill={color}
            d="M3.8,10.9H0.8c-0.4,0-0.8,0.3-0.8,0.8v3.5C0,15.7,0.4,16,0.8,16h2.9c0.4,0,0.8-0.3,0.8-0.8v-3.5C4.5,11.3,4.2,10.9,3.8,10.9z M3.2,14.6H1.4v-2.3h1.8V14.6z"
          />
          <path
            fill={color}
            d="M9.4,8.6H6.5C6.1,8.6,5.7,9,5.7,9.4v5.8c0,0.4,0.4,0.8,0.8,0.8h2.9c0.4,0,0.8-0.4,0.8-0.8V9.4C10.2,9,9.8,8.6,9.4,8.6z M8.8,14.6H7.1V10h1.8V14.6z"
          />
          <path
            fill={color}
            d="M15.1,6.3h-2.8c-0.5,0-0.8,0.4-0.8,0.8v8.1c0,0.5,0.4,0.8,0.8,0.8h2.8c0.5,0,0.8-0.4,0.8-0.8V7.1C16,6.6,15.6,6.3,15.1,6.3z M14.6,14.6h-1.8v-7h1.8V14.6z"
          />
        </Icon>
      );
    case IconTypeE.calendar:
      return (
        <Icon viewBox="0 0 16 16">
          <path
            fill={color}
            d="M8,8.9c0.1,0,0.3,0,0.4-0.1c0.1-0.1,0.2-0.2,0.3-0.3c0.1-0.1,0.1-0.3,0-0.4c0-0.1-0.1-0.3-0.2-0.4C8.4,7.7,8.3,7.6,8.1,7.6c-0.1,0-0.3,0-0.4,0C7.6,7.7,7.5,7.8,7.4,7.9C7.3,8,7.3,8.1,7.3,8.3c0,0.2,0.1,0.4,0.2,0.5C7.6,8.9,7.8,8.9,8,8.9z M12.5,8.9c0.1,0,0.3,0,0.4-0.1c0.1-0.1,0.2-0.2,0.3-0.3c0.1-0.1,0.1-0.3,0-0.4c0-0.1-0.1-0.3-0.2-0.4c-0.1-0.1-0.2-0.2-0.4-0.2c-0.1,0-0.3,0-0.4,0c-0.1,0.1-0.2,0.1-0.3,0.3c-0.1,0.1-0.1,0.2-0.1,0.4c0,0.2,0.1,0.4,0.2,0.5S12.3,8.9,12.5,8.9z M8,12.9c0.1,0,0.3,0,0.4-0.1c0.1-0.1,0.2-0.2,0.3-0.3c0.1-0.1,0.1-0.3,0-0.4c0-0.1-0.1-0.3-0.2-0.4c-0.1-0.1-0.2-0.2-0.4-0.2s-0.3,0-0.4,0c-0.1,0.1-0.2,0.1-0.3,0.3c-0.1,0.1-0.1,0.2-0.1,0.4c0,0.2,0.1,0.4,0.2,0.5C7.6,12.8,7.8,12.9,8,12.9z M12.5,12.9c0.1,0,0.3,0,0.4-0.1c0.1-0.1,0.2-0.2,0.3-0.3c0.1-0.1,0.1-0.3,0-0.4c0-0.1-0.1-0.3-0.2-0.4c-0.1-0.1-0.2-0.2-0.4-0.2c-0.1,0-0.3,0-0.4,0c-0.1,0.1-0.2,0.1-0.3,0.3c-0.1,0.1-0.1,0.2-0.1,0.4c0,0.2,0.1,0.4,0.2,0.5C12.2,12.8,12.3,12.9,12.5,12.9z M3.5,8.9c0.1,0,0.3,0,0.4-0.1C4,8.8,4.1,8.6,4.1,8.5c0.1-0.1,0.1-0.3,0-0.4C4.1,8,4.1,7.9,4,7.8C3.9,7.7,3.7,7.6,3.6,7.6c-0.1,0-0.3,0-0.4,0C3.1,7.7,3,7.8,2.9,7.9C2.8,8,2.8,8.1,2.8,8.3c0,0.2,0.1,0.4,0.2,0.5C3.1,8.9,3.3,8.9,3.5,8.9z M13.9,1.7h-0.7V1.1c0-0.2-0.1-0.4-0.2-0.5c-0.1-0.1-0.3-0.2-0.5-0.2S12.2,0.4,12,0.6c-0.1,0.1-0.2,0.3-0.2,0.5v0.7H4.2V1.1c0-0.2-0.1-0.4-0.2-0.5C3.8,0.4,3.7,0.4,3.5,0.4C3.3,0.4,3.1,0.4,3,0.6C2.9,0.7,2.8,0.9,2.8,1.1v0.7H2.1C1.5,1.7,1,2,0.6,2.4C0.2,2.8,0,3.3,0,3.8v9.7c0,0.6,0.2,1.1,0.6,1.5c0.4,0.4,0.9,0.6,1.5,0.6h11.8c0.6,0,1.1-0.2,1.5-0.6c0.4-0.4,0.6-0.9,0.6-1.5V3.8c0-0.6-0.2-1.1-0.6-1.5C15,2,14.5,1.7,13.9,1.7z M14.6,13.6c0,0.2-0.1,0.4-0.2,0.5c-0.1,0.1-0.3,0.2-0.5,0.2H2.1c-0.2,0-0.4-0.1-0.5-0.2c-0.1-0.1-0.2-0.3-0.2-0.5V5.9h13.2V13.6z M14.6,4.5H1.4V3.8c0-0.2,0.1-0.4,0.2-0.5c0.1-0.1,0.3-0.2,0.5-0.2h11.8c0.2,0,0.4,0.1,0.5,0.2c0.1,0.1,0.2,0.3,0.2,0.5V4.5z M3.5,12.9c0.1,0,0.3,0,0.4-0.1c0.1-0.1,0.2-0.2,0.3-0.3c0.1-0.1,0.1-0.3,0-0.4c0-0.1-0.1-0.3-0.2-0.4c-0.1-0.1-0.2-0.2-0.4-0.2c-0.1,0-0.3,0-0.4,0c-0.1,0.1-0.2,0.1-0.3,0.3c-0.1,0.1-0.1,0.2-0.1,0.4c0,0.2,0.1,0.4,0.2,0.5C3.1,12.8,3.3,12.9,3.5,12.9z"
          />
        </Icon>
      );
  }
};
